import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link, useHistory } from 'react-router-dom'
import Select, { components } from 'react-select';
import moment from 'moment';
import { Modal } from "react-bootstrap";
import uuid from 'react-uuid';
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { Tooltip } from "antd";

import country_arr from './common_arr/countries-arr.js';
import s_a from './common_arr/states-arr.js';
import product_unit_arr from './common_arr/product-unit-arr.js';
import { useTheme } from "./theme-provider.js"
import { getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js";
import Dropzone from 'react-dropzone';
import formatNumber from '../common_component/formatNumber.js';
import PageError from '../common_component/PageError.js';
import { useModal } from '../providers/modal-provider.js';


function EditCreditNote(props) {
    const [state, setstate] = useState(2);
    const [failedPageMessage, setFailedPageMessage] = useState("Something went wrong. Please reload this page.")
    const history = useHistory()
    const { theme, dropdownStyleDark } = useTheme()

    const [customerApiState, setCustomerApiState] = useState(false);
    const customerListApiController = useRef(new AbortController())

    const [itemApiState, setItemApiState] = useState(false);
    const itemListApiController = useRef(new AbortController())

    const [customerList, setCustomerList] = useState([])
    const [branchList, setBranchlist] = useState([])
    const [transactionSeriesList, setTransactionSeriesList] = useState([])
    const [allItemList, setAllItemList] = useState([])
    const [itemList, setItemList] = useState([])
    const [userList, setUserList] = useState([])
    const [invoiceList, setInvoiceList] = useState([])
    const [invoiceListApiState, setInvoiceListApiState] = useState([])
    const [salesReturnList, setSalesReturnList] = useState([])
    const [salesReturnListApiState, setSalesReturnListApiState] = useState([])
    const [termsList, setTermsList] = useState([])
    const [currencyList, setCurrencyList] = useState([])
    const [currencyExchangeRates, setCurrencyExchangeRates] = useState([])
    const [organizationDetails, setOrganizationDetails] = useState(null)
    const [addressList, setAddressList] = useState([]);
    const [customerGstinList, setCustomerGstinList] = useState([]);
    const [SupplyStateOptions, setSupplyStateOptions] = useState([]);
    const [warehouseList, setWarehouseList] = useState([])
    const [taxGroupList, setTaxGroupList] = useState([]);
    const [taxList, setTaxList] = useState([])
    const [customerInvoiceDetails, setCustomerInvoiceDetails] = useState([]);
    const [deleteCreditNoteApiState, setDeleteCreditNoteApiState] = useState(false)

    const creditNoteTypeList = ["Direct", "By Invoice", "By Sales Return"];
    const reasonList = ["Sales Return", "Inadequate service", "Others"];
    const invoiceTypeList = ["Registered", "Export With Payment", "Export Without Payment"];

    const [creditNoteType, setCreditNoteType] = useState("Direct");
    const [selectedOrganizationGstin, setSelectedOrganizationGstin] = useState(null)
    const [organizationGstinList, setOrganizationGstinList] = useState([])
    const [uploadedDocuments, setUploadedDocuments] = useState([]);
    const [previouslyUploadedDocuments, setPreviouslyUploadedDocuments] = useState([])

    const [selectedCustomerFullDetails, setSelectedCustomerFullDetails] = useState(null)
    const [selectedCustomer, setSelectedCustomer] = useState(null)
    const [selectedCustomerEmail, setSelectedCustomerEmail] = useState(null)
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedSalesReturn, setSelectedSalesReturn] = useState(null);
    const [selectedReason, setSelectedReason] = useState(null);
    const [selectedInvoiceType, setSelectedInvoiceType] = useState(null);
    const [selectedTransactionSeries, setSelectedTransactionSeries] = useState(null);

    const [selectedBillingAddress, setSelectedBillingAddress] = useState(null)
    const [selectedShippingAddress, setSelectedShippingAddress] = useState(null)
    const [addressApiState, setAddressApiState] = useState(false)

    const [selectedGstin, setSelectedGstin] = useState(null)
    const [invoiceNumber, setInvoiceNumber] = useState("")
    const [creditNoteNumber, setCreditNoteNumber] = useState("")
    const [referenceNumber, setReferenceNumber] = useState("")
    const [sourceOfSupply, setSourceOfSupply] = useState(null)
    const [selectedPlaceOfSupply, setSelectedPlaceOfSupply] = useState(null);
    const [invoiceDate, setInvoiceDate] = useState(moment.utc().format('YYYY-MM-DD'))
    const [selectedTerm, setSelectedTerm] = useState(null)
    const [dueDate, setDueDate] = useState(moment.utc().add(5, "days").format('YYYY-MM-DD'))
    const [selectedUser, setSelectedUser] = useState(null)
    const [selectedCurrency, setSelectedCurrency] = useState(null)
    const [selectedWarehouse, setSelectedWarehouse] = useState(null)
    const [subject, setSubject] = useState("")
    const [adjustment, setAdjustment] = useState({ text: "Adjustment", value: 0 })
    const [selectedTaxCategory, setSelectedTaxCategory] = useState(null)
    const [selectedTax, setSelectedTax] = useState(null)
    const [customerNotes, setCustomerNotes] = useState("")
    const [termsAndConditions, setTermsAndConditions] = useState("")

    const [itemArray, setItemArray] = useState([{ item: null, item_data: null, stock_data: [], item_type: "", item_code: "", quantity: 1, quantity_unit: null, quantity_max: 0, rate: 0, line_total: 0 }])
    const [grandTotal, setGrandTotal] = useState(0)

    const [approvalInfo, setApprovalInfo] = useState(null)

    const [submitButtonState, setSubmitButtonState] = useState(false);

    const [productCodeModalShow, setProductCodeModalShow] = useState(false)
    const [productCodeItemId, setProductCodeItemId] = useState(null)
    const [productCodeItemType, setProductCodeItemType] = useState(null)
    const [productCodeSearch, setProductCodeSearch] = useState("")
    const [productCodeList, setProductCodeList] = useState([])
    const [productCodeListApiState, setProductCodeListApiState] = useState(false)

    const [gstInListModalShow, setGstInListModalShow] = useState(false);
    const [creditNoteDetails, setCreditNoteDetails] = useState(null)

    const [props_type, setprops_type] = useState("");
    const [props_value, setprops_value] = useState("");

    const [ItemModalShow, setItemModalShow] = useState(false);
    const [Product_type, setProduct_type] = useState("Goods");
    const [ItemName, setItemName] = useState("");
    const [UnitSelectionList, setUnitSelectionList] = useState([]);
    const [Unit, setUnit] = useState("8");
    const [TaxSelectionList, setTaxSelectionList] = useState([{ label: "Taxable", value: "Taxable" }, { label: "Non Taxable", value: "Non Taxable" }, { label: "Out of Scope", value: "Out of Scope" }, { label: "Non-GST Supply", value: "Non-GST Supply" }]);
    const [TaxPreference, setTaxPreference] = useState("Taxable");
    const [TaxCalculationMethod, setTaxCalculationMethod] = useState("TAX_Inclusive")
    const [Default_tax_preference, setDefault_tax_preference] = useState({ "Inter_State_Tax": "", "Intra_State_Tax": "" });
    const [Tracking_inventory, setTracking_inventory] = useState(false);
    const [Tracking_inventory_type, setTracking_inventory_type] = useState("");
    const [itemSubmitButtonState, setitemSubmitButtonState] = useState(false);

    const [AddressModalShow, setAddressModalShow] = useState(false);
    const [AddressType, setAddressType] = useState("");

    const [CustomerModalShow, setCustomerModalShow] = useState(false);
    const [productId, setProductId] = useState("");
    const [BatchInModalShow, setBatchInModalShow] = useState(false);
    const [SerialInModalShow, setSerialInModalShow] = useState(false);
    const [Selected_multiple_serial, setSelected_multiple_serial] = useState([]);
    const [Quantity_adjust, setQuantity_adjust] = useState(0);
    const [stockData, setStockData] = useState([]);
    const [SerialName, setSerialName] = useState("");
    const [ScannerModalShow, setScannerModalShow] = useState(false);

    const [customerSubmitButtonState, setCustomerSubmitButtonState] = useState(false);

    const [customerType, setCustomerType] = useState("individual")
    const [primaryContact, setPrimaryContact] = useState({ salutation: null, firstName: "", lastName: "" })
    const [customerDisplayNameOptions, setCustomerDisplayNameOptions] = useState([])
    const [selectedCustomerDisplayName, setSelectedCustomerDisplayName] = useState(null)
    const [workPhone, setWorkPhone] = useState("");
    const [mobile, setMobile] = useState("")
    const [email, setEmail] = useState("")

    const [Shipping_flag, setShipping_flag] = useState(false);

    const [billingAddressFlag, setBillingAddressFlag] = useState(false)
    const [billingCountryOptions, setBillingCountryOptions] = useState([]);
    const [billingStateOptions, setBillingStateOptions] = useState([]);
    const [billingSelectedCountry, setBillingSelectedCountry] = useState({ label: "India", value: "India" })
    const [billingSelectedState, setBillingSelectedState] = useState({ label: "West Bengal", value: "West Bengal" })
    const [billingCity, setBillingCity] = useState("");
    const [billingAddress1, setBillingAddress1] = useState("")
    const [billingPincode, setBillingPincode] = useState("");

    const [LegalName, setLegalName] = useState("");
    const [TradeName, setTradeName] = useState("");
    const [GstIN, setGstIN] = useState("");
    const [placeSupply, setPlaceSupply] = useState(null);
    const [gstTreatment, setGstTreatment] = useState({ label: "Unregistered Business", value: "Unregistered Business", description: "Business that has not been registered under GST" })

    const [termsModalShow, setTermsModalShow] = useState(false)
    const [termsPanelList, setTermsPanelList] = useState([])
    const [termsSubmitButtonState, setTermsSubmitButtonState] = useState(false);

    const { openModal, setModalView, setModalData } = useModal()

    const webcamRef = useRef(null);
    const [selectedCamera, setSelectedCamera] = useState("user");

    const search_length = 2;

    var page_name = "edit-credit-note";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    let formatNumberOptions = {
        removeTrailingZeros: true
    }

    const capture = (err, result) => {
        if (!result)
            return

        let tag = result.text;
        //console.log(tag);
        setSelected_multiple_serial((temp) => {
            //console.log(stockData);
            let values1 = temp.map(x => { return { ...x } })
            let Duplicate = stockData.find(s => s.serialName == tag);
            //let Duplicate1 = available_serial_number.find(s => s.serialName == tag);
            let Duplicate2 = values1.find(s => s.serialName == tag);
            if ((typeof (Duplicate) !== "undefined" && JSON.stringify(Duplicate).length > 0) || (typeof (Duplicate2) !== "undefined" && JSON.stringify(Duplicate2).length > 0)) {
                swal("Warning!", "This Serial Number already exist.Try different one.", "warning").then((value) => {
                    //setSerialName("");
                });
                return values1
            }
            else {
                if ((Number(Quantity_adjust) - stockData.length) - values1.length == 0) {
                    swal("Warning!", "You can't add no more serial.because quantity is already adjusted", "warning").then((value) => {
                        //setSerialName("");
                    });
                    return values1
                }
                else if ((Number(Quantity_adjust) - stockData.length) > 1) {
                    values1.push({ uid: uuid(), serialName: tag });
                    return values1;
                }
                else {
                    let values2 = stockData.map(x => { return { ...x } })
                    values2.push({ uid: uuid(), serialName: tag });
                    setStockData(values2);
                    setScannerModalShow(false);
                    return values1;
                }
            }
        });
    }

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    const gstTreatmentlist = [
        { label: "Registered Business-Regular", value: "Registered Business-Regular", description: "A business that is registered under GST" },
        { label: "Unregistered Business", value: "Unregistered Business", description: "Business that has not been registered under GST" }
    ]

    const Remove_serial_batch_section = (index) => {
        const temp_arr = [...stockData];
        temp_arr.splice(index, 1);
        setStockData(temp_arr);
    }

    const Add_serial_batch_section = () => {
        const temp_arr = [...stockData];
        if (Tracking_inventory === "Track Batches") {
            if (Math.sign(Number(Quantity_adjust)) === 1) {
                temp_arr.push({ uid: uuid(), Batch_Reference: "", Manufacture_Batch: "", Manufacture_Date: "", existing_flag: false, Expiry_Date: "", Quantity_In: 0 });
            }
            setStockData(temp_arr);
        }
        else {
            if (SerialName != "") {
                var Duplicate = stockData.find(s => s.serialName == SerialName);
                //var Duplicate1 = available_serial_number.find(s => s.serialName == SerialName);

                if ((typeof (Duplicate) !== "undefined" && JSON.stringify(Duplicate).length > 0)) {
                    swal("Warning!", "This Serial Number already exist.Try different one.", "warning").then((value) => {
                        setSerialName("");
                    });
                }
                else {
                    SearchBatchSerialInformation(SerialName, "Serial", "");
                }
            }
            else {
                swal("Warning!", "Serial Number can't be blank.", "warning").then((value) => {
                    setSerialName("");
                });
            }
        }
    }

    const Remove_multiple_scan_serial = (index) => {
        const values1 = [...Selected_multiple_serial];
        values1.splice(index, 1);
        setSelected_multiple_serial(values1);
    }

    const Merge_multiple_scan_serial = () => {
        const values1 = [...stockData];
        const values2 = [...Selected_multiple_serial];
        let temp = values1.concat(values2);
        setStockData(temp);
        setSelected_multiple_serial([]);
        setScannerModalShow(false);
    }

    async function SearchBatchSerialInformation(val, type, index) {
        var object = {};
        object.email = user.email;
        setSubmitButtonState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-stock-data-by-search`, { method: 'POST', body: JSON.stringify({ "product_id": productId, "search_val": val,/*"Branch_name": Branch_name, "Warehouse_name": Warehouse_name,*/"email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation === "success") {
            setSubmitButtonState(false)
            if (body.data.search_results === true) {
                swal("Oops!", `This ${type} Number already exist!`, "warning");
                if (type === "Batch") {
                    const values1 = [...stockData];
                    values1[index].Batch_Reference = "";
                    setStockData(values1);
                }
                return false;
            }
            else {
                let temp_arr = [...stockData];
                if (type === "Serial") {
                    temp_arr.push({ uid: uuid(), serialName: val });
                }
                setStockData(temp_arr);
                setSerialName("");
            }
        }
    }

    async function getOrganizationGstinList() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-gst-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        if (body.operation === "success") {
            setOrganizationGstinList(body.data)
        }
    }

    useEffect(() => {
        var obj_array = [];
        var Productunitarr = product_unit_arr.product_unit_arr;
        for (let k = 0; k < Productunitarr.length; k++) {
            var obj2 = {};
            obj2.label = Productunitarr[k].Short_term + "(" + Productunitarr[k].Unit + ")";
            obj2.value = Productunitarr[k].id;
            obj_array.push(obj2);
        }
        setUnitSelectionList(obj_array);
    }, [])

    useEffect(() => {
        if ((taxGroupList.length > 0) && (currencyList.length > 0) && itemArray.length > 0) {
            if (creditNoteType == "Direct") {
                setGrandTotal(trimDecimalPlaces(itemArray.reduce((p, o) => { return p + (o.quantity * o.rate) }, 0), selectedCurrency == null ? 3 : currencyList.find(x => x.currency_id == selectedCurrency.value).decimal_place))
            }
            else if (creditNoteType == "By Invoice" && selectedInvoice !== null) {
                if (itemArray.find(x => x.item !== null)) {
                    setGrandTotal(trimDecimalPlaces(selectedInvoice.item_list.filter(item => itemArray.map(x => { return x.item.value }).includes(item.item_id)).reduce((p, o) => {

                        const quantity = itemArray.find(x => x.item.value = o.item_id).quantity;
                        return (p + (((quantity * o.rate) - (o.discount_type === "amount" ? o.discount_unit : quantity * o.rate * o.discount_unit / 100)) + (o.taxable === 0 ? 0 : ((quantity * o.rate) - (o.discount_type === "amount" ? o.discount_unit : quantity * o.rate * o.discount_unit / 100)) * (o.tax_group_percentage / 100))));

                    }, 0), selectedCurrency == null ? 3 : currencyList.find(x => x.currency_id == selectedCurrency.value).decimal_place))
                }
            }
        }
    }, [itemArray, selectedCurrency, currencyList, taxGroupList, creditNoteType, selectedInvoice])

    useEffect(() => {
        setSelectedCustomerDisplayName(null)
        let tempArr = []
        if (primaryContact.salutation !== null) {
            if (primaryContact.firstName.trim() !== "") {
                if (primaryContact.lastName.trim() !== "") {
                    tempArr.push(primaryContact.salutation.value + " " + primaryContact.firstName + " " + primaryContact.lastName, primaryContact.firstName + " " + primaryContact.lastName, primaryContact.lastName + ", " + primaryContact.firstName)
                }
                else {
                    tempArr.push(primaryContact.salutation.value + " " + primaryContact.firstName, primaryContact.firstName)
                }
            }
            else {
                if (primaryContact.lastName.trim() !== "") {
                    tempArr.push(primaryContact.salutation.value + " " + primaryContact.lastName, primaryContact.lastName)
                }
            }
        }
        else {
            if (primaryContact.firstName.trim() !== "") {
                if (primaryContact.lastName.trim() !== "") {
                    tempArr.push(primaryContact.firstName + " " + primaryContact.lastName, primaryContact.lastName + ", " + primaryContact.firstName)
                }
                else {
                    tempArr.push(primaryContact.firstName)
                }
            }
            else {
                if (primaryContact.lastName.trim() !== "") {
                    tempArr.push(primaryContact.lastName)
                }
            }
        }
        setSelectedCustomerDisplayName({ label: tempArr[0], value: tempArr[0] })
        setCustomerDisplayNameOptions(tempArr)
    }, [primaryContact])

    useEffect(() => {
        let state_arr = s_a.s_a[country_arr.country_arr.findIndex((obj) => obj == "India")].split("|");
        let obj_array = [];
        for (let i = 0; i < state_arr.length; i++) {
            obj_array.push({ value: state_arr[i], label: state_arr[i] });
        }
        setSupplyStateOptions(obj_array);
    }, []);

    async function getCustomers(search_value) {
        try {
            if (customerApiState) {
                customerListApiController.current.abort()
                customerListApiController.current = new AbortController()
            }
            setCustomerApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-customer-by-search`, { signal: customerListApiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_value, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            // console.log(body.data)

            if (body.operation === "success") {
                setCustomerList(body.data.list.filter(x => x.add_status == "Active"))
                setCustomerApiState(false);

                return body.data.list
            }
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getCreditNoteDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-credit-note-details`, { method: 'POST', body: JSON.stringify({ "id": props.match.params.id, "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation == "success") {
            if (body.data.add_status == "CREDIT_NOTE_PENDING_APPROVAL" || body.data.add_status == "CREDIT_NOTE_DRAFT" || body.data.add_status == "CREDIT_NOTE_APPROVED") {
                setCreditNoteDetails(body.data)
            }
            else {
                throw (<span>{body.data.credit_note_number} is not allowed to edit</span>)
            }
        }
        else {
            throw "No data is available"
        }
    }

    async function getCustomerInvoicesBySearch(customer_id, search_value) {
        try {
            if (invoiceListApiState) {
                customerListApiController.current.abort()
                customerListApiController.current = new AbortController()
            }
            setInvoiceListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-customer-invoice-by-search`, { signal: customerListApiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "customer_id": customer_id, "search_value": search_value, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            // console.log(body.data)

            if (body.operation === "success") {
                setInvoiceList(body.data.filter(x => x.add_status === "CUSTOMER_INVOICE_FINALIZED")
                    .map(x => ({
                        label: x.customer_invoice_number,
                        value: x.customer_invoice_id,
                        item_list: x.item_array,
                        credit_notes: x.credit_notes
                    })))
                setInvoiceListApiState(false);

                return body.data.list
            }
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getSalesReturnBySearch(customer_id, search_value) {
        try {
            if (salesReturnListApiState) {
                customerListApiController.current.abort()
                customerListApiController.current = new AbortController()
            }
            setSalesReturnListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-sales-return-by-search`, { signal: customerListApiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "customer_id": customer_id, "search_value": search_value, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            // console.log(body.data)

            if (body.operation === "success") {
                setSalesReturnList(body.data.map(x => { return { label: x.sales_return_number, value: x.sales_return_id, customer_invoice_id: x.customer_invoice_id, item_list: x.item_array } }))
                setSalesReturnListApiState(false);

                return body.data.list
            }
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function deleteCreditNote(filename) {
        setDeleteCreditNoteApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/delete-credit-note-document`, { method: 'POST', body: JSON.stringify({ "email": user.email, "id": creditNoteDetails.credit_note_id, "filename": filename, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        setDeleteCreditNoteApiState(false)

        if ((body.operation == "success")) {
            return true
        } else return false
    }

    async function getBranchDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-branches`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation == "success") {
            setBranchlist(body.data);
            let t = body.data.find(x => x.default_branch == "yes")
            setSelectedBranch({ label: t.branch_name, value: t.branch_id })
        }
        else {
            throw "branch list api error"
        }
    }

    async function getTransactionSeriesList() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-transaction-series-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        if (body.operation == "success") {
            setTransactionSeriesList(body.data)
        }
        else {
            throw "transaction series api list error"
        }
    }

    async function getItems(search_value, signal_flag = true) {
        try {
            if (itemApiState) {
                itemListApiController.current.abort()
                itemListApiController.current = new AbortController()
            }

            setItemApiState(true);
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-product-by-search`, { signal: signal_flag ? itemListApiController.current.signal : undefined, method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_value, "type": "Customer", "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            // console.log(body)
            setItemApiState(false);
            if (body.operation === "success") {
                setItemList(body.data.map(x => { return { label: x.product_name, value: x.pid } }));
                setAllItemList(body.data);
                return body.data;
            }
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getItemsById(product_ids) {
        try {
            if (itemApiState) {
                itemListApiController.current.abort()
                itemListApiController.current = new AbortController()
            }

            setItemApiState(true);
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-product-by-ids`, { signal: itemListApiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "product_ids": product_ids, "type": "Customer", "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            // console.log(body)
            if (body.operation === "success") {
                setItemList(body.data.list);
                setItemApiState(false);
            }
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getuserdetails() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-user-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        setUserList(body)
    }

    async function getWarehouses() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/list-warehouse`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setWarehouseList(body.data)
        }
    }

    async function getTaxGroupDetails() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/tax-group-datatable`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body.data)

        if ((body.operation == "success") && (body.data.length > 0)) {
            setTaxGroupList(body.data);
        }
    }

    async function getTerms() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-invoice-terms`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        if (body.length != 0) {
            setTermsList(body)
        }
    }

    async function getCurrencyList() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/currency-datatable`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        if (body.data.length != 0) {
            setCurrencyList(body.data)
        }
    }

    async function getCurrencyExchangeRates() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-live-currency`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        if (body.length != 0) {
            setCurrencyExchangeRates(body[0])
        }
    }

    async function getTdsTcsTaxes() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/tax-datatable`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body.data)

        if (body.operation == "success") {
            setTaxList(body.data);
        }
        else {
            throw "tds tcs tax get api error"
        }
    }

    async function getOrganizationDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/show-organization`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        if (body.length != 0) {
            setOrganizationDetails(body.find(x => x.organization_id == getCookie("organization_id")))
        }
    }

    async function getAddressDetails(val) {
        setAddressApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-customer-addresses`, { method: 'POST', body: JSON.stringify({ "email": user.email, "cid": val, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if ((body.operation == "success") && (body.data.length > 0)) {
            setAddressList(body.data[0].address_details)
            body.data[0].address_details.find(x => x.address_type == "billing") && setSelectedBillingAddress(body.data[0].address_details.find(x => x.address_type == "billing"))
            body.data[0].address_details.find(x => x.address_type == "shipping") && setSelectedShippingAddress(body.data[0].address_details.find(x => x.address_type == "shipping"))
        }
        setAddressApiState(false)
    }

    async function getCustomerGstinDetails(val) {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-customer-tax-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "cid": val, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if ((body.operation == "success") && (body.data.length > 0)) {
            let t = body.data.find(x => x.flag == "Primary")
            if (t) {
                setSelectedGstin(t)
                // console.log(t);
                setSelectedPlaceOfSupply({ label: t.place_of_supply, value: t.place_of_supply })
            }
            else {
                let temp = body.data
                temp.sort((a, b) => new Date(a.add_date_time) - new Date(b.add_date_time))
                let temp2 = temp[0]
                setSelectedGstin(temp2)
                setSelectedPlaceOfSupply({ label: temp2.place_of_supply, value: temp2.place_of_supply })
            }

            setCustomerGstinList(body.data);
        }
        else {
            throw "tax details api error"
        }
    }

    async function getProductCodeList(type, val) {
        setProductCodeListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-product-hsn-code`, { method: 'POST', body: JSON.stringify({ "email": user.email, "search_type": type === "Goods" ? "HSN" : "SAC", "search_key": val, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body.data)

        if (body.operation == "success") {
            setProductCodeList(body.data)
            setProductCodeListApiState(false)
        }
        else {
            throw "get product code list api error"
        }
    }

    async function getApprovalDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-specific-approval`, {
            method: 'POST', body: JSON.stringify({ "organization_id": organization_id, "key": "credit_note_approval", "email": user.email, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") }
        });
        const body = await response.json();
        if (body.operation === "success") {
            setApprovalInfo(body.data);
        }
    }

    async function getCustomerInvoiceDetails(customer_invoice_id) {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-customer-invoice-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "customer_invoice_id": customer_invoice_id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body.data)

        if (body.operation == "success") {
            setCustomerInvoiceDetails(body.data[0])
            return body.data[0]
        }
        else {
            throw "get customer invoice details api error"
        }
    }

    useEffect(() => {
        if (creditNoteDetails != null && creditNoteDetails.credit_note_type !== "Direct") {
            if (creditNoteDetails.credit_note_type == "By Invoice" && invoiceList.length > 0) {
                const inv_details = invoiceList.find(x => x.value == creditNoteDetails.selected_invoice.inv_id);
                setSelectedInvoice({ label: inv_details.label, value: inv_details.value, item_list: inv_details.item_list });
                getItemsById(inv_details.item_list.map(x => { return x.item_id }));
            }
            else if (creditNoteDetails.credit_note_type == "By Sales Return" && salesReturnList.length > 0) {
                const sr_details = salesReturnList.find(x => x.value == creditNoteDetails.selected_sr.sr_id);
                setSelectedSalesReturn({ label: sr_details.label, value: sr_details.value, item_list: sr_details.item_list });
                getItemsById(sr_details.item_list.map(x => { return x.item_id }));
            }
        }
    }, [creditNoteDetails, invoiceList, salesReturnList])

    useEffect(() => {
        if ((customerInvoiceDetails != null) && (creditNoteDetails != null) && (branchList.length > 0) && (transactionSeriesList.length > 0) && (warehouseList.length > 0)) {
            setSelectedCustomer({ label: creditNoteDetails.customer_name, value: creditNoteDetails.customer_id })
            setSelectedBranch({ label: creditNoteDetails.branch_name, value: creditNoteDetails.branch_id });
            setSourceOfSupply(warehouseList.find(x => x.wid == creditNoteDetails.warehouse_id).state)
            setSelectedTransactionSeries({ label: transactionSeriesList.find(x => x.transaction_series_id == creditNoteDetails.transaction_series_id).series_name, value: creditNoteDetails.transaction_series_id });
            setSelectedBillingAddress(creditNoteDetails.billing_address)
            setSelectedShippingAddress(creditNoteDetails.shipping_address)
            setSelectedGstin(creditNoteDetails.gstin_details)
            setCreditNoteNumber(creditNoteDetails.credit_note_number)
            setCreditNoteType(creditNoteDetails.credit_note_type)
            setReferenceNumber(creditNoteDetails.reference_number)
            setSelectedPlaceOfSupply({ label: creditNoteDetails.place_of_supply, value: creditNoteDetails.place_of_supply });
            if (creditNoteDetails.credit_note_type == "By Invoice") {
                setSelectedInvoiceType({ label: creditNoteDetails.selected_invoice_type, value: creditNoteDetails.selected_invoice_type });
            }
            if (customerInvoiceDetails?.organization_gstin_number && customerInvoiceDetails?.organization_gstin_id) {
                setSelectedOrganizationGstin({ label: customerInvoiceDetails.organization_gstin_number, value: customerInvoiceDetails.organization_gstin_id, legal_name: organizationGstinList.find(x => x.unique_id == customerInvoiceDetails.organization_gstin_id).legal_name, trade_name: organizationGstinList.find(x => x.unique_id == customerInvoiceDetails.organization_gstin_id).trade_name })
            }
            setSelectedReason(creditNoteDetails.reason);
            setInvoiceDate(moment(creditNoteDetails.credit_note_date).format('YYYY-MM-DD'))
            setSelectedTerm(creditNoteDetails.term == null ? null : { label: creditNoteDetails.term.term_name, value: creditNoteDetails.term.term_days })
            setPreviouslyUploadedDocuments(creditNoteDetails.documents)
            setDueDate(moment(creditNoteDetails.due_date).format('YYYY-MM-DD'))
            if (creditNoteDetails.salesperson_email !== null) {
                setSelectedUser({ label: creditNoteDetails.salesperson_name + " - " + creditNoteDetails.salesperson_email, value: creditNoteDetails.salesperson_email })
            }
            setSelectedCurrency({ label: creditNoteDetails.credit_note_currency.currency_code, value: creditNoteDetails.credit_note_currency.currency_id })
            setSelectedWarehouse({ label: warehouseList.find(x => x.wid == creditNoteDetails.warehouse_id).name, value: creditNoteDetails.warehouse_id })
            setSubject(creditNoteDetails.subject)
            setAdjustment(creditNoteDetails.adjustment)
            setSelectedTaxCategory(creditNoteDetails.tax_category)
            setSelectedTax(creditNoteDetails.tax_id == null ? null : { label: `${creditNoteDetails.tax_name} (${creditNoteDetails.tax_percentage}%)`, value: creditNoteDetails.tax_id })
            setCustomerNotes(creditNoteDetails.customer_notes)
            setTermsAndConditions(creditNoteDetails.terms_and_conditions);
            let temp = creditNoteDetails.item_array.map(async (item) => {
                let pr_ac = item.quantity_max;
                if (creditNoteDetails.credit_note_type == "Direct") {
                    let t = await getItems(item.item_id, false)
                    pr_ac = (t[0].product_details.length > 0 && t[0].product_details.find(x => creditNoteDetails.branch_id == x.branch_id && creditNoteDetails.warehouse_id == x.warehouse_id) !== undefined) ? t[0].product_details.find(x => creditNoteDetails.branch_id == x.branch_id && creditNoteDetails.warehouse_id == x.warehouse_id).available_count : 0;
                }

                return {
                    item: { label: item.item_name, value: item.item_id },
                    item_data: [],
                    stock_data: item.stock_data,
                    item_type: item.item_type,
                    tracking_inventory_type: item.item_stock_type,
                    quantity: item.quantity,
                    quantity_unit: item.quantity_unit,
                    quantity_max: pr_ac,
                    rate: item.rate,
                    line_total: item.line_total
                }

            })
            Promise.all(temp)
                .then((val) => {
                    console.log(val);
                    setItemArray(val);
                })
                .catch((err) => {
                    console.log(err);
                })

        }
    }, [creditNoteDetails, branchList, transactionSeriesList, warehouseList])

    useEffect(() => {
        if (((read) || (write)) && (user.email && visibility)) {
            let p0 = getCreditNoteDetails()
            let p1 = getCustomers()
            let p2 = getBranchDetails()
            let p3 = getTransactionSeriesList()
            let p4 = getWarehouses()
            let p5 = getTaxGroupDetails()
            let p6 = getTdsTcsTaxes()
            let p7 = getuserdetails()
            let p8 = getCurrencyList()
            let p9 = getCurrencyExchangeRates()
            let p10 = getOrganizationDetails()
            let p11 = getItems(null)
            let p12 = getTerms()
            let p13 = getApprovalDetails();
            let p14 = getOrganizationGstinList()

            Promise.all([p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12, p13, p14])
                .then(async () => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    setFailedPageMessage(err)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    useEffect(() => {
        if (selectedCustomer != null) {
            let p1 = getAddressDetails(selectedCustomer.value)
            let p2 = getCustomerGstinDetails(selectedCustomer.value)
            Promise.all([p1, p2])
                .then(() => {
                    console.log("address details api, tax details api done")
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }, [selectedCustomer])

    useEffect(() => {
        if ((stockData.length > 0)) {
            let temp = itemArray.map(a => { return { ...a } });
            temp.find(x => x.item.value == productId).stock_data = stockData
            setItemArray(temp)
        }
    }, [stockData])

    useEffect(() => {
        if ((selectedBranch != null) && (transactionSeriesList.length > 0) && (warehouseList.length > 0) && (organizationGstinList.length > 0)) {
            let tb = branchList.find(x => x.branch_id == selectedBranch.value)

            let tg = organizationGstinList.find(x => x.branch_list.includes(selectedBranch.value))
            setSelectedOrganizationGstin({ label: tg.GstIn, value: tg.unique_id })

            let twl = warehouseList.filter(x => x.branch_id == selectedBranch.value)
            if (twl.length > 0) {
                twl.sort((a, b) => new Date(a.add_date_time) - new Date(b.add_date_time))
                let temp = twl[0]
                setSelectedWarehouse({ label: temp.name, value: temp.wid })
                setSourceOfSupply(temp.state);
            }
            else {
                let tw = warehouseList.find(x => x.default == 1)
                setSelectedWarehouse({ label: tw.name, value: tw.wid })
                setSourceOfSupply(tw.state);
            }
        }
    }, [selectedBranch, transactionSeriesList, warehouseList])

    const submitItemDetails = () => {

        var values = {
            "ItemName": ItemName,
            "Unit": Unit,
            "Sku": "",
            "Product_type": Product_type,
            "Manufacturer": "",
            "SubCategory": "",
            "Category": "",
            "Brand": "",
            "Hsn_code": "",
            "Sac_code": "",
            "Tracking_inventory": Tracking_inventory,
            "Tracking_inventory_type": Tracking_inventory_type,
            "Shipping_flag": 0,
            "Shipping_info": JSON.stringify([{ "Weight": "", "Dimension": { "Width": "", "Height": "", "Length": "" } }]),
            "Specification_info": JSON.stringify({ "MPN": "", "ICBN": "", "UPC": "", "EAN": "" }),
            "TaxPreference": TaxPreference,
            "Tax_Calculation_Method": TaxCalculationMethod,
            "Default_tax_preference": JSON.stringify(Default_tax_preference),
            "organization_id": organization_id,
            "page_name": page_name,
        };

        if (ItemName.trim().length == 0) {
            swal("Warning!", "Please enter a Item Name", "warning");
            return false;
        }
        if (Unit.length == 0) {
            swal("Warning!", "Please select a unit", "warning");
            return false;
        }

        setitemSubmitButtonState(true);
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/product`, values, headers).then((res) => {
            setitemSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Item details saved successfully!", "success").then((value) => {
                    getItems();
                    setItemModalShow(false);
                    //window.location.reload();
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const trimDecimalPlaces = (amt, decimal_place) => {
        return Math.round(amt * Math.pow(10, decimal_place)) / Math.pow(10, decimal_place)
    }

    const reset_serial_batch_section = () => {
        let temp = itemArray.map(a => { return { ...a } });
        temp.find(x => x.item.value == productId).stock_data = stockData
        setItemArray(temp);
        if (Tracking_inventory === "Track Serial Number") {
            if (Math.sign(Number(temp.find(x => x.item.value == productId).quantity)) === 1) {
                setStockData([]);
            }
        }
        else if (Tracking_inventory === "Track Batches") {
            if (Math.sign(Number(temp.find(x => x.item.value == productId).quantity)) === 1) {
                setStockData([{ uid: uuid(), Batch_Reference: "", Manufacture_Batch: "", Manufacture_Date: "", existing_flag: false, Expiry_Date: "", Quantity_In: 0 }]);
            }
        }
    }

    const validateCreditNote = () => {
        if (selectedCustomer == null) {
            swal("Oops!", "Customer cannot be empty", "warning");
            return false
        }
        if (selectedBranch == null) {
            swal("Oops!", "Branch cannot be empty", "warning");
            return false
        }
        if (selectedTransactionSeries == null) {
            swal("Oops!", "Transaction Series cannot be empty", "warning");
            return false
        }
        if (selectedOrganizationGstin == null) {
            swal("Oops!", "Organization Gstin cannot be empty", "warning");
            return false
        }
        if (selectedBillingAddress == null) {
            swal("Oops!", "Billing Address cannot be empty", "warning");
            return false
        }
        if (selectedShippingAddress == null) {
            swal("Oops!", "Shipping Address cannot be empty", "warning");
            return false
        }
        if (selectedGstin == null) {
            swal("Oops!", "Gstin cannot be empty", "warning");
            return false
        }
        if (creditNoteType == "By Invoice" && selectedInvoice == null) {
            swal("Oops!", "Invoice number field cannot be empty", "warning");
            return false
        }
        if (creditNoteType == "By Sales Return") {
            if (selectedSalesReturn == null) {
                swal("Oops!", "Sales return field cannot be empty", "warning");
                return false
            }
            if (Number(grandTotal) == 0) {
                swal("Oops!", "Grand total field cannot be zero", "warning");
                return false
            }
        }
        if (selectedPlaceOfSupply == null) {
            swal("Oops!", "Place of Supply cannot be empty", "warning");
            return false
        }
        if (invoiceDate == "") {
            swal("Oops!", "invoice Date cannot be empty", "warning");
            return false
        }
        if (dueDate == "") {
            swal("Oops!", "Due Date cannot be empty", "warning");
            return false
        }
        if (selectedCurrency == null) {
            swal("Oops!", "Currency cannot be empty", "warning");
            return false
        }
        if (selectedWarehouse == null) {
            swal("Oops!", "Warehouse cannot be empty", "warning");
            return false
        }
        if ((selectedTaxCategory != null) && (selectedTax == null)) {
            swal("Oops!", "Select TDS or TCS tax", "warning");
            return false
        }

        if (creditNoteType !== "By Sales Return") {
            for (let i = 0; i < itemArray.length; i++) {
                let obj = itemArray[i]
                if (obj.item == null) {
                    swal("Oops!", "Item cannot be empty", "error");
                    return
                }

                if (obj.taxable == true && obj.tax == null) {
                    swal("Oops!", "Select a tax for the taxable item", "warning");
                    return
                }
                if (creditNoteType === "Direct" && (obj.tracking_inventory_type === "Track Serial Number" || obj.tracking_inventory_type === "Track Batches")) {
                    if (!stockValidationCheck(obj.item.value)) {
                        return
                    }
                }
                return true
            }
        }

    }

    const stockValidationCheck = (pid) => {
        let tempObj = itemArray.find(x => x.item.value == pid);
        if (tempObj.tracking_inventory_type === "Track Serial Number" || tempObj.tracking_inventory_type === "Track Batches") {
            if (Number(tempObj.quantity) == 0) {
                swal("Oops!", "Adjust quantity can't be zero.", "warning")
                return false
            }
            else {
                let mismatch_flag = false;
                let zero_quantity_flag = false;
                let blank_batch_field = false;
                if (tempObj.tracking_inventory_type === "Track Serial Number") {
                    if (Math.sign(Number(tempObj.quantity)) === 1) {
                        ///for add serials
                        mismatch_flag = (tempObj.stock_data.length !== Math.abs(tempObj.quantity));

                    }
                }
                else if (tempObj.tracking_inventory_type === "Track Batches") {
                    if (Math.sign(Number(tempObj.quantity)) === 1) {
                        ///for add batches
                        const totalQuantityIn = tempObj.stock_data.reduce(function (sum, batch) {
                            return Number(sum) + Number(batch.Quantity_In);
                        }, 0);
                        mismatch_flag = (totalQuantityIn !== (Number(tempObj.quantity)));
                        console.log(tempObj.stock_data);
                        zero_quantity_flag = tempObj.stock_data.find(s => s.Quantity_In == 0) !== undefined ? true : false;
                        blank_batch_field = tempObj.stock_data.find(s => s.Batch_Reference == "") !== undefined ? true : false;

                    }
                }
                console.log(mismatch_flag, zero_quantity_flag, blank_batch_field)
                if (mismatch_flag) {
                    swal("Oops!", `Mismatch between Adjust Quantity and Adjusted Quantity for ${tempObj.item.label}`, "warning")
                    return false
                }
                if (zero_quantity_flag) {
                    swal("Oops!", `Quantity field can't be zero ${tempObj.item.label}`, "warning")
                    return false
                }
                if (blank_batch_field) {
                    swal("Oops!", `Batch field blank somewhere ${tempObj.item.label}`, "warning")
                    return false
                }
                return true
            }
        }
    }

    const existingCreditNoteUpdate = (val) => {
        const object = new FormData()
        object.append("id", props.match.params.id)
        object.append("credit_note_type", creditNoteType)
        object.append("customer_id", selectedCustomer.value)
        object.append("customer_name", selectedCustomer.label)
        object.append("customer_email", selectedCustomerEmail)
        object.append("branch_id", selectedBranch.value)
        object.append("transaction_series_id", selectedTransactionSeries.value)

        object.append("billing_address", JSON.stringify(selectedBillingAddress))
        object.append("shipping_address", JSON.stringify(selectedShippingAddress))
        object.append("gstin", JSON.stringify(selectedGstin))
        object.append("gstin_number", selectedGstin.GstIn)
        object.append("reference_number", referenceNumber.trim())
        object.append("place_of_supply", selectedPlaceOfSupply.value)
        object.append("credit_note_date", invoiceDate)
        object.append("term", (selectedTerm == null) ? null : JSON.stringify({ term_name: selectedTerm.label, term_days: selectedTerm.value }))
        object.append("reason", selectedReason == null ? "" : selectedReason)

        if (creditNoteType == "By Invoice") {
            object.append("selected_invoice", JSON.stringify(selectedInvoice))
            object.append("selected_invoice_type", selectedInvoiceType == null ? "" : selectedInvoiceType.value)
        }
        else if (creditNoteType == "By Sales Return") {
            object.append("selected_sr", JSON.stringify(selectedSalesReturn))
        }

        object.append("additional_user_email", selectedUser ? selectedUser.value : "")
        object.append("additional_user_name", selectedUser ? userList.find(x => x.user_id == selectedUser.value).name : "")
        object.append("organization_gstin_number", selectedOrganizationGstin.label)
        object.append("organization_gstin_id", selectedOrganizationGstin.value)
        object.append("subject", subject)

        let temp = []
        itemArray.forEach((obj) => {
            let tobj = {}
            tobj.item_name = obj.item.label
            tobj.item_id = obj.item.value
            tobj.item_type = obj.item_type
            tobj.stock_data = obj.stock_data
            tobj.item_stock_type = obj.tracking_inventory_type
            tobj.quantity = obj.quantity
            tobj.quantity_max = obj.quantity_max
            tobj.quantity_unit = obj.quantity_unit
            tobj.rate = obj.rate
            tobj.line_total = obj.line_total

            temp.push(tobj)
        })

        object.append("item_array", JSON.stringify(temp))

        object.append("grand_total", grandTotal)
        object.append("customer_notes", customerNotes)
        object.append("terms_and_conditions", termsAndConditions)
        uploadedDocuments.forEach(obj => {
            object.append("data_files", obj)
        })

        object.append("save_flag", val)
        object.append("organization_id", organization_id)
        object.append("page_name", page_name)
        setSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-credit-note`, object, headers).then((res) => {
            setSubmitButtonState(false)
            console.log(res);
            if (res.data.operation === "success") {
                swal("Great!", `Credit note updated successfully!`, "success").then(() => {
                    history.go(0)
                }
                );
            }
            else if (res.data.operation === "duplicate") {
                swal("Oops!", "This Reference Number already exists!!", "error");
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const newTermsSubmit = () => {
        let f1 = true
        termsPanelList.forEach(obj => {
            if ((obj.term_name.trim() == "") || (obj.no_of_days == "")) {
                f1 = false
            }
        })
        if (f1 == false) {
            swal("Oops!", "Term Name or No of Days cannot be empty", "warning");
            return
        }

        let temp = termsPanelList.map(obj => { return obj.term_name.trim() })
        if (temp.length != [... new Set(temp)].length) {
            swal("Oops!", "Term Name cannot be a duplicate", "warning");
            return
        }

        var object = {};

        object.terms_panel_list = termsPanelList

        object.organization_id = organization_id
        object.page_name = page_name;

        // console.log(object);
        setTermsSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-invoice-terms`, object, headers).then((res) => {
            setTermsSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", "Terms added successfully!", "success")
                handleNewTermsModalClose()
                getTerms()
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const handleNewTermsModalClose = () => {
        setTermsModalShow(false)
        setTermsPanelList([])
    }

    useEffect(() => {
        let obj_array = []
        country_arr.country_arr.forEach((obj, index) => {
            if (index !== 0) {
                let obj2 = {};
                obj2.label = obj;
                obj2.value = obj;

                obj_array.push(obj2);
            }
        })
        setBillingCountryOptions(obj_array);
    }, []);

    useEffect(() => {
        if (creditNoteType !== null && selectedCustomer !== null) {
            if (creditNoteType == "By Invoice") {
                getCustomerInvoicesBySearch(selectedCustomer.value, "")
            }
            else if (creditNoteType == "By Sales Return") {
                getSalesReturnBySearch(selectedCustomer.value, "")
            }
        }
    }, [creditNoteType, selectedCustomer]);

    function loadBillingStateOptions(country) {
        let selectedCountryIndex = 0;
        billingCountryOptions.forEach((obj, index) => {
            if (obj.value === country.value) {
                selectedCountryIndex = index;
            }
        })

        let state_arr = s_a.s_a[selectedCountryIndex + 1].split("|");
        let obj_array = [];
        for (let i = 0; i < state_arr.length; i++) {
            obj_array.push({ value: state_arr[i], label: state_arr[i] });
        }
        setBillingStateOptions(obj_array);
    }

    const clearFormCustomer = () => {
        setCustomerModalShow(false)
        setCustomerType("");
        setPrimaryContact({
            salutation: null,
            firstName: "",
            lastName: "",
        });
        setSelectedCustomerDisplayName(null);
        setWorkPhone("");
        setMobile("");
        setEmail("");
        setPlaceSupply(null);
        setGstTreatment(null);
        setGstIN("");
        setLegalName("");
        setTradeName("");
        setBillingSelectedCountry(null);
        setBillingSelectedState(null);
        setBillingCity("");
        setBillingAddress1("");
        setBillingPincode("");
        setShipping_flag(false);
    };

    const gstinRegex = /^[0-9A-Za-z]{15}$/;
    const submitCustomerDetails = () => {
        // var nexp = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~0-9]/;
        if ((!primaryContact.firstName.trim()) && (!primaryContact.lastName.trim())) {
            swal("Warning!", "Primary Contact must contain first name or last name", "warning");
            return
        }

        if (selectedCustomerDisplayName === null) {
            swal("Warning!", "Customer Display Name cannot be empty", "warning");
            return
        }

        if (workPhone === "") {
            swal("Warning!", "Work phone cannot be empty", "warning");
            return
        }
        let regex1 = /^(\+\d{1,3}[- ]?)?\d{10}$/
        if (!regex1.test(workPhone)) {
            swal("Warning!", "Please provide valid Work phone number", "warning");
            return
        }

        let regex2 = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        if ((email !== "") && (!regex2.test(email))) {
            swal("Warning!", "Please enter a valid Email id", "warning");
            return false;
        }

        if (gstTreatment === null) {
            swal("Warning!", "GST Treatment cannot be empty", "warning");
            return
        }
        else {
            if (gstTreatment.value === "Registered Business-Regular") {
                if (GstIN === "") {
                    swal("Warning!", "GSTIN cannot be empty", "warning");
                    return
                }
                if (!gstinRegex.test(GstIN)) {
                    swal("Warning!", "Invalid GSTIN format", "warning");
                    return;
                }
                if (TradeName === "") {
                    swal("Warning!", "Business Trade Name cannot be empty", "warning");
                    return
                }
                if (LegalName === "") {
                    swal("Warning!", "Business Legal Name cannot be empty", "warning");
                    return
                }
            }
        }

        if (placeSupply === null) {
            swal("Warning!", "Supply Place cannot be empty", "warning");
            return
        }

        let object = {};

        let pin_regex = /^\d{5,6}$/
        let billing_arr = [];
        let billing_country = (billingSelectedCountry === null) ? null : billingSelectedCountry.value
        let billing_state = (billingSelectedState === null) ? null : billingSelectedState.value

        object.billingAddressFlag = false;
        if (billingCity || billing_country || billing_state || billingPincode) {
            if (!billingCity.trim()) {
                billing_arr.push("City");
            }
            if (!billing_country) {
                billing_arr.push("Country");
            }
            if (!billing_state) {
                billing_arr.push("State");
            }
            if (!billingPincode || !pin_regex.test(billingPincode)) {
                billing_arr.push("PinCode");
            }
        }
        if (billing_arr.length > 0) {
            setBillingAddressFlag(true);
            swal("Warning!", billing_arr.join(", ") + " field can't be empty.", "warning");
            return
        }
        else {
            object.billingAddressFlag = true;
        }

        const shiprocketRegex = /^(?=.*\b\d+\b).{11,}$/;
        if (!billingAddress1.match(shiprocketRegex)) {
            swal("Warning!", "Incorrect Format: Address Line 1 must have a separate number and be at least 11 characters long.", "warning");
            return
        }

        object.gstTreatment = gstTreatment.value;
        object.placeSupply = placeSupply.value;

        object.gst_details = { GstIN: GstIN, LegalName: LegalName, TradeName: TradeName };

        object.customer_type = customerType
        object.primary_contact = { ...primaryContact, salutation: primaryContact.salutation === null ? null : primaryContact.salutation.value }
        object.customer_display_name = selectedCustomerDisplayName.value
        object.work_phone = workPhone
        object.mobile = mobile
        object.email = email
        object.lead_source = "CRM"
        object.currency = { currency_code: "", currency_id: "" };
        object.address_details = {
            "country": (billingSelectedCountry === null) ? null : billingSelectedCountry.value,
            "state": (billingSelectedState === null) ? null : billingSelectedState.value,
            "city": billingCity,
            "address_line1": (billingAddress1 === "") ? "" : billingAddress1,
            "pincode": billingPincode
        };


        object.organization_id = organization_id;
        object.page_name = page_name;

        object.company_name = "";
        object.mobile = null;
        object.designation = "";
        object.website = "";
        object.identity_type = "";
        object.identity_number = "";
        object.pan = "";
        object.term = null;
        object.portal_check = "";
        object.portal_language = null;
        object.facebook_link = null;
        object.twitter_link = null;
        object.contact_persons_array = [];
        object.remarks = null;
        object.billing_map_coordinates = "";
        object.bankDetailsArray = [];
        object.childDetailsArray = [];
        object.file_names = [];
        object.profile_photo = "";

        object.billing_attention = "";
        object.billing_country = billingSelectedCountry.value;
        object.billing_state = billingSelectedState.value;
        object.billing_city = billingCity;
        object.billing_pincode = billingPincode;
        object.billing_address1 = billingAddress1;
        object.billing_address2 = "";
        object.billing_phone = "";
        object.billing_fax = "";
        object.billing_delivery_instruction = "";
        object.billing_map_coordinates = "";

        object.shippingAddressFlag = Shipping_flag;

        object.shipping_attention = "";
        object.shipping_country = Shipping_flag ? billingSelectedCountry.value : null;
        object.shipping_state = Shipping_flag ? billingSelectedState.value : null;
        object.shipping_city = Shipping_flag ? billingCity : "";
        object.shipping_pincode = Shipping_flag ? billingPincode : "";
        object.shipping_address1 = Shipping_flag ? billingAddress1 : "";
        object.shipping_address2 = "";
        object.shipping_phone = "";
        object.shipping_fax = "";
        object.shipping_delivery_instruction = "";
        object.shipping_map_coordinates = "";

        setCustomerSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/customers`, object, headers).then(async (res) => {
            setCustomerSubmitButtonState(false);
            if (res.data.operation === "success") {
                swal("Great!", "Customer added successfully!", "success")

                let cd = await getCustomers(res.data.data.cid)

                clearFormCustomer();
                setCustomerModalShow(false);
                setSelectedCustomer({ label: res.data.data.customer_display_name, value: res.data.data.cid })

                setSelectedCustomerFullDetails(cd[0]);
                setSelectedCustomerEmail(cd[0].email);

                setSelectedBillingAddress(null);
                setSelectedShippingAddress(null);
                setSelectedGstin(null);
                setSelectedPlaceOfSupply(null);
            }
            else if (res.data.operation === "same_email") {
                swal("Oops!", res.data.message, "error");
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    async function resetCommonValue(inv_info) {
        setSourceOfSupply(null);
        setSelectedTransactionSeries(null);
        //setSelectedCurrency(null);
        setSelectedWarehouse(null);
        setSelectedBillingAddress(null);
        setSelectedShippingAddress(null);
        setSelectedGstin(null);
        setSelectedOrganizationGstin(null);
        if (inv_info) {
            const invoice_details = inv_info;
            setSourceOfSupply(warehouseList.find(x => x.wid == invoice_details.warehouse_id).state)
            setSelectedTransactionSeries({ label: transactionSeriesList.find(x => x.transaction_series_id == invoice_details.transaction_series_id).series_name, value: invoice_details.transaction_series_id });
            setSelectedCurrency({ label: invoice_details.invoice_currency.currency_code, value: invoice_details.invoice_currency.currency_id })
            setSelectedWarehouse({ label: warehouseList.find(x => x.wid == invoice_details.warehouse_id).name, value: invoice_details.warehouse_id })
            setSelectedBillingAddress(invoice_details.billing_address)
            setSelectedShippingAddress(invoice_details.shipping_address)
            setSelectedGstin(invoice_details.gstin_details)
            if (invoice_details.organization_gstin_number !== undefined) {
                setSelectedOrganizationGstin({ label: invoice_details.organization_gstin_number, value: invoice_details.organization_gstin_id })
            }
        }
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Update Credit Note</h1>
                    <Tooltip title="SpotERP Docs" >
                        <a
                            href={`${process.env.REACT_APP_SPOTERP_DOCS}/sales/credit_note`}
                            className='btn btn-light-primary py-2 px-3'
                            target="_blank"
                        >
                            <i className="bi bi-journal-text fs-1 px-0"></i>
                        </a>
                    </Tooltip>
                </div>
                <div>
                    {
                        ((!approvalInfo || approvalInfo.type === "not_configure") && state === 1) &&
                        <>
                            <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed  p-6">
                                <span className="svg-icon svg-icon-2tx svg-icon-warning me-4"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                    <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="currentColor"></rect>
                                    <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="currentColor"></rect>
                                </svg>
                                </span>
                                <div className="d-flex flex-stack flex-grow-1 ">
                                    <div className=" fw-semibold">
                                        <div className="fs-6 text-gray-700 ">Credit Note Approval Part Not Configured yet. Configure this, From <Link to={"/approvals"}>Approval Page</Link>.</div>
                                    </div>
                                </div>
                            </div><br />
                        </>
                    }
                    <div className="card">
                        <div className="card-body">

                            {
                                state == 1 ?
                                    <>
                                        <div className="row mb-sm-5 gx-0 ">
                                            <div className="col-md-4 px-1 mb-2">
                                                <label className="required fs-5 fw-bold mb-2">Type</label>
                                                <Select
                                                    options={creditNoteTypeList.map(x => { return { label: x, value: x } })}
                                                    value={{ label: creditNoteType, value: creditNoteType }}
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    isDisabled
                                                />
                                            </div>
                                            <div className="col-md-4 px-1 mb-2">
                                                <label className="required fs-5 fw-bold mb-2">Customer Name</label>
                                                <Select
                                                    options={customerList.map(x => { return { label: x.customer_display_name, value: x.cid } })}
                                                    // onChange={(val) => {
                                                    //     setSelectedCustomer(val);
                                                    //     if (val) {
                                                    //         setSelectedCustomerFullDetails(customerList.find(x => x.cid == val.value));
                                                    //         setSelectedCustomerEmail(customerList.find(x => x.cid == val.value).email);
                                                    //     }
                                                    //     else {
                                                    //         setSelectedCustomerFullDetails(null);
                                                    //         setSelectedCustomerEmail(null);
                                                    //     }
                                                    //     setSelectedBillingAddress(null);
                                                    //     setSelectedShippingAddress(null);
                                                    //     setSelectedGstin(null);
                                                    //     setSelectedPlaceOfSupply(null);
                                                    // }}
                                                    value={selectedCustomer}
                                                    placeholder="search or add Customer..."
                                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                                    onInputChange={(val) => { (val.length > search_length) && getCustomers(val) }}
                                                    isLoading={customerApiState}
                                                    isDisabled
                                                    components={{
                                                        MenuList: (props) => {
                                                            return (
                                                                <components.MenuList  {...props}>
                                                                    {props.children}
                                                                    <div className='d-flex justify-content-center'>
                                                                        <button className='btn btn-primary rounded btn-sm my-1' onClick={() => { setCustomerModalShow(true) }} ><i className="bi bi-file-earmark-plus"></i> Add Customer</button>
                                                                    </div>
                                                                </components.MenuList >
                                                            )
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="required fs-5 fw-bold mb-2">Credit Note Date</label>
                                                <input type="date" className="form-control form-control-solid" max={moment.utc().format("YYYY-MM-DD")}
                                                    value={invoiceDate} onChange={(e) => {
                                                        setInvoiceDate(e.target.value);
                                                        setSelectedTerm(null);
                                                    }} />
                                            </div>
                                        </div>

                                        <div className="row gx-0" style={{ transition: "all 1s ease-in-out", opacity: !addressApiState && selectedCustomer != null ? "1" : "0", visibility: !addressApiState && selectedCustomer != null ? "visible" : "hidden", height: !addressApiState && selectedCustomer != null ? "auto" : "0", marginBottom: !addressApiState && selectedCustomer != null ? "1rem" : "0" }}>
                                            <div className="col-md-6 mt-2 px-1">
                                                <div className="card p-4 flex-row shadow-sm rounded">
                                                    <div className="d-flex flex-column flex-grow-1">
                                                        <div className="d-flex align-items-center fs-5 fw-bold mb-3 text-primary">
                                                            Billing Address
                                                            <button onClick={(e) => { setAddressModalShow(true); setAddressType("billing") }} className="btn btn-sm btn-outline-primary ms-3">
                                                                <i className="fa-solid fa-pencil fs-5"></i>
                                                            </button>
                                                        </div>
                                                        {selectedBillingAddress != null ? (
                                                            <div className="bg-light p-3 rounded shadow-sm">
                                                                <div className="address-info mb-2">
                                                                    <span className="fw-semibold text-muted">Address 1: </span>
                                                                    <span className="fs-6 text-dark fw-bold">{selectedBillingAddress.address_line1 || "NA"}</span>
                                                                </div>
                                                                {selectedBillingAddress.address_line2 && (
                                                                    <div className="address-info mb-2">
                                                                        <span className="fw-semibold text-muted">Address 2: </span>
                                                                        <span className="fs-6 text-dark fw-bold">{selectedBillingAddress.address_line2}</span>
                                                                    </div>
                                                                )}
                                                                <div className="address-info mb-2">
                                                                    <div className="row">
                                                                        <div className="col">
                                                                            <span className="fw-semibold text-muted">City: </span>
                                                                            <span className="fs-6 text-dark fw-bold">{selectedBillingAddress.city}</span>
                                                                        </div>
                                                                        <div className="col">
                                                                            <span className="fw-semibold text-muted">Pincode: </span>
                                                                            <span className="fs-6 text-dark fw-bold">{selectedBillingAddress.pincode}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="address-info">
                                                                    <div className="row">
                                                                        <div className="col">
                                                                            <span className="fw-semibold text-muted">State: </span>
                                                                            <span className="fs-6 text-dark fw-bold">{selectedBillingAddress.state}</span>
                                                                        </div>
                                                                        <div className="col">
                                                                            <span className="fw-semibold text-muted">Country: </span>
                                                                            <span className="fs-6 text-dark fw-bold">{selectedBillingAddress.country}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="bg-light p-3 rounded shadow-sm text-muted">No Billing Address Added. Please select an address.</div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6 mt-2 px-1">
                                                <div className="card p-4 flex-row shadow-sm rounded">
                                                    <div className="d-flex flex-column flex-grow-1">
                                                        <div className="d-flex align-items-center fs-5 fw-bold mb-3 text-primary">
                                                            Shipping Address
                                                            <button onClick={(e) => { setAddressModalShow(true); setAddressType("shipping") }} className="btn btn-sm btn-outline-primary ms-3">
                                                                <i className="fa-solid fa-pencil fs-5"></i>
                                                            </button>
                                                        </div>
                                                        {selectedShippingAddress != null ? (
                                                            addressApiState ? (
                                                                <div className="spinner-border text-primary"></div>
                                                            ) : (
                                                                <div className="bg-light p-3 rounded shadow-sm">
                                                                    <div className="address-info mb-2">
                                                                        <span className="fw-semibold text-muted">Address 1: </span>
                                                                        <span className="fs-6 text-dark fw-bold">{selectedShippingAddress.address_line1 || "NA"}</span>
                                                                    </div>
                                                                    {selectedShippingAddress.address_line2 && (
                                                                        <div className="address-info mb-2">
                                                                            <span className="fw-semibold text-muted">Address 2: </span>
                                                                            <span className="fs-6 text-dark fw-bold">{selectedShippingAddress.address_line2}</span>
                                                                        </div>
                                                                    )}
                                                                    <div className="address-info mb-2">
                                                                        <div className="row">
                                                                            <div className="col">
                                                                                <span className="fw-semibold text-muted">City: </span>
                                                                                <span className="fs-6 text-dark fw-bold">{selectedShippingAddress.city}</span>
                                                                            </div>
                                                                            <div className="col">
                                                                                <span className="fw-semibold text-muted">Pincode: </span>
                                                                                <span className="fs-6 text-dark fw-bold">{selectedShippingAddress.pincode}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="address-info">
                                                                        <div className="row">
                                                                            <div className="col">
                                                                                <span className="fw-semibold text-muted">State: </span>
                                                                                <span className="fs-6 text-dark fw-bold">{selectedShippingAddress.state}</span>
                                                                            </div>
                                                                            <div className="col">
                                                                                <span className="fw-semibold text-muted">Country: </span>
                                                                                <span className="fs-6 text-dark fw-bold">{selectedShippingAddress.country}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        ) : (
                                                            <div className="bg-light p-3 rounded shadow-sm text-muted">No Shipping Address Added. Please select an address.</div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row gx-0" style={{ transition: "all 1s ease-in-out", opacity: selectedCustomer != null ? "1" : "0", visibility: selectedCustomer != null ? "visible" : "hidden", height: selectedCustomer != null ? "auto" : "0", marginBottom: selectedCustomer != null ? "1rem" : "0" }}>
                                            <div className="col-12">
                                                <div className="bg-light border border-primary d-flex flex-column w-100 p-5 rounded shadow-sm">
                                                    <h5 className="d-flex align-items-center mb-4">
                                                        <span className="badge bg-primary text-white mx-3">GST Details</span>
                                                        <span className="font-weight-semi-bold text-dark">{selectedGstin && customerGstinList.filter(customer => customer.GstIn !== "").length > 0 ? `GST Count: ${customerGstinList.filter(customer => customer.GstIn !== "").length}` : ""}</span>
                                                    </h5>
                                                    <div className="d-flex flex-wrap align-items-center gap-2">
                                                        {selectedGstin !== null ? (
                                                            <>
                                                                <div className="border border-gray-300 border-dashed rounded py-3 px-4 mx-3 flex-grow-1 bg-white shadow-sm">
                                                                    <span className="fs-6 text-dark fw-bold">{selectedGstin.gst_treatment}</span>
                                                                    <div className="fw-semibold text-muted">GST Treatment</div>
                                                                </div>
                                                                {(selectedGstin.gst_treatment !== "Unregistered Business" && selectedGstin.gst_treatment !== "Consumer") && (
                                                                    <div className="border border-gray-300 border-dashed rounded py-3 px-4 mx-3 flex-grow-1 bg-white shadow-sm">
                                                                        <span className="fs-6 text-dark fw-bold">{selectedGstin.GstIn}</span>
                                                                        <div className="fw-semibold text-muted">GSTIN</div>
                                                                    </div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <div className="border border-gray-300 border-dashed rounded py-3 px-4 mx-3 flex-grow-1 bg-white shadow-sm">
                                                                <span className="fs-6 text-dark fw-bold">No GSTIN selected</span>
                                                            </div>
                                                        )}
                                                        <div>
                                                            <button onClick={(e) => { setGstInListModalShow(true); }} className="btn btn-sm btn-primary px-3">
                                                                <i className="fa-solid fa-pencil fs-5 text-white"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="text-muted fs-7 mt-3">Set or add GST.</div>
                                            </div>
                                        </div>

                                        <div className="row mb-5">
                                            {creditNoteType == "By Invoice" ?
                                                <>
                                                    <div className="col-md-4 mb-2">
                                                        <label className="required fs-5 fw-bold mb-2">Invoice number</label>
                                                        {props_type === "INVOICE" ?
                                                            <input type="text" className="form-control form-control-solid" value={invoiceNumber} readOnly disabled />
                                                            :
                                                            <Select
                                                                options={invoiceList}
                                                                onChange={(val) => {
                                                                    setGrandTotal(0);
                                                                    setItemArray([{ item: null, item_data: null, stock_data: [], item_type: "", item_code: "", quantity: 1, quantity_unit: null, quantity_max: 0, rate: 0, line_total: 0 }]);
                                                                    if (val.credit_notes.length == 0) {
                                                                        setSelectedInvoice(val);
                                                                        resetCommonValue(val);
                                                                        setItemList(val.item_list.map(x => { return { label: x.item_name, value: x.item_id } }));
                                                                    }
                                                                    else {
                                                                        resetCommonValue(null);
                                                                        setItemList([]);
                                                                        swal("Oops!", "A pending credit note already exists for this invoice.", "warning");
                                                                        return false
                                                                    }
                                                                }}
                                                                onInputChange={(val) => { (val.length > search_length && selectedCustomer !== null) && getCustomerInvoicesBySearch(selectedCustomer.value, val) }}
                                                                value={selectedInvoice}
                                                                placeholder="Select Invoice..."
                                                                styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                isLoading={invoiceListApiState}
                                                            />
                                                        }
                                                    </div>
                                                    <div className="col-md-4 mb-2">
                                                        <label className="fs-5 fw-bold mb-2">Invoice Type</label>
                                                        <Select
                                                            options={invoiceTypeList.map(x => { return { label: x, value: x } })}
                                                            onChange={(val) => { setSelectedInvoiceType(val) }}
                                                            value={selectedInvoiceType}
                                                            placeholder="Select Invoice Type..."
                                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                        //isDisabled={props.match.params.id}
                                                        />
                                                    </div>
                                                </>
                                                :
                                                creditNoteType == "By Sales Return" &&
                                                <>
                                                    <div className="col-md-6 mb-2">
                                                        <label className="fs-5 fw-bold mb-2">Select Sales Return</label>
                                                        {props_type === "INVOICE" ?
                                                            <input type="text" className="form-control form-control-solid" value={invoiceNumber} readOnly disabled />
                                                            :
                                                            <Select
                                                                options={salesReturnList}
                                                                onChange={async (val) => {
                                                                    setSelectedSalesReturn(val);
                                                                    //setGrandTotal(0);
                                                                    resetCommonValue(val.customer_invoice);
                                                                    const temp = await getCustomerInvoiceDetails(val.customer_invoice_id);
                                                                    const updated_item_array = val.item_list.map((item) => {
                                                                        const invoice_item = temp.item_array.find(x => x.item_id == item.item_id);
                                                                        const quantity = item.challan_info.reduce((p1, o1) => { return p1 + Number(o1.returned_quantity) }, 0);
                                                                        const line_total = trimDecimalPlaces((((quantity * invoice_item.rate) - (invoice_item.discount_type == "amount" ? invoice_item.discount_unit : quantity * invoice_item.rate * invoice_item.discount_unit / 100)) + (invoice_item.tax_group_id == null ? 0 : ((quantity * invoice_item.rate) - (invoice_item.discount_type == "amount" ? invoice_item.discount_unit : quantity * invoice_item.rate * invoice_item.discount_unit / 100)) * (invoice_item.tax_group_percentage / 100))), temp.invoice_currency.decimal_place)
                                                                        return { item: { label: invoice_item.item_name, value: invoice_item.item_id }, item_data: [], stock_data: [], item_type: invoice_item.item_type, quantity: quantity, quantity_unit: invoice_item.quantity_unit, quantity_max: invoice_item.quantity_max, rate: invoice_item.rate, line_total: line_total }

                                                                    })
                                                                    setItemArray(updated_item_array);
                                                                    setGrandTotal(Math.round(val.item_list.reduce((p, o) => {
                                                                        const invoice_item = temp.item_array.find(x => x.item_id == o.item_id);
                                                                        const quantity = o.challan_info.reduce((p1, o1) => { return p1 + Number(o1.returned_quantity) }, 0);
                                                                        return (p + (((quantity * invoice_item.rate) - (invoice_item.discount_type === "amount" ? invoice_item.discount_unit : quantity * invoice_item.rate * invoice_item.discount_unit / 100)) + (invoice_item.taxable === 0 ? 0 : ((quantity * invoice_item.rate) - (invoice_item.discount_type === "amount" ? invoice_item.discount_unit : quantity * invoice_item.rate * invoice_item.discount_unit / 100)) * (invoice_item.tax_group_percentage / 100))));
                                                                    }, 0) * temp.invoice_currency.decimal_place / temp.invoice_currency.decimal_place));
                                                                }}
                                                                onInputChange={(val) => { (val.length > search_length && selectedCustomer !== null) && getSalesReturnBySearch(selectedCustomer.value, val) }}
                                                                value={selectedSalesReturn}
                                                                placeholder="Select Sales Return..."
                                                                styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                isLoading={salesReturnListApiState}
                                                            //isDisabled={props.match.params.id}
                                                            />
                                                        }
                                                    </div>
                                                    <div className="col-md-6 mb-2">
                                                        <label className="required fs-5 fw-bold mb-2">Amount</label>
                                                        <div className="input-group input-group-solid mb-5">
                                                            <span className="input-group-text">{currencyList.find(x => x.currency_id == selectedCurrency.value).currency_symbol}</span>
                                                            <input type="number" className="form-control" value={grandTotal.toString()} min="0"
                                                                //onChange={(e) => { setGrandTotal(e.target.value == "" ? 0 : parseFloat(e.target.value)); }}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </div>

                                        <div className="row mb-5">
                                            <div className="col-md-4">
                                                <label className="fs-5 fw-bold mb-2 required">Warehouse</label>
                                                <Select
                                                    options={warehouseList.map(x => { return { label: x.name, value: x.wid } })}
                                                    onChange={(val) => {
                                                        swal("Alert!", "Please verify applicable taxes for selected items", "info")
                                                        setSelectedWarehouse(val);
                                                        setSourceOfSupply(warehouseList.find(x => x.wid == val.value).state);
                                                    }}
                                                    value={selectedWarehouse}
                                                    isDisabled
                                                    placeholder="Select Warehouse..."
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="required fs-5 fw-bold mb-2">Place Of Supply</label>
                                                <Select
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    options={SupplyStateOptions}
                                                    onChange={(val) => {
                                                        swal("Alert!", "Please verify applicable taxes for selected items", "info")
                                                        setSelectedPlaceOfSupply(val)
                                                    }}
                                                    value={selectedPlaceOfSupply}
                                                    isDisabled
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fs-5 fw-bold mb-2 required">Currency</label>
                                                <Select
                                                    options={currencyList.map(x => { return { label: x.currency_code, value: x.currency_id } })}
                                                    onChange={(val) => { setSelectedCurrency(val) }}
                                                    value={selectedCurrency}
                                                    isDisabled
                                                    components={{
                                                        MenuList: (props) => {
                                                            return (
                                                                <components.MenuList  {...props}>
                                                                    {props.children}
                                                                    <div className='d-flex justify-content-center'>
                                                                        <button className='btn btn-success rounded btn-sm my-1'
                                                                            onClick={() => {
                                                                                setModalData({
                                                                                    apiCallback: (data) => { getCurrencyList(); setSelectedCurrency({ label: data.currency_code, value: data.currency_id }) },
                                                                                    page_name,
                                                                                })
                                                                                setModalView("CURRENCY_MODAL")
                                                                                openModal()
                                                                            }}>
                                                                            &#10011; Add New Currency
                                                                        </button>
                                                                    </div>
                                                                </components.MenuList >
                                                            )
                                                        }
                                                    }}
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                />
                                            </div>
                                        </div>

                                        <div className="row mb-5">
                                            <div className="col-md-4 px-1 mb-2">
                                                <label className="required fs-5 fw-bold mb-2">Branch:</label>
                                                <Select
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    options={branchList.map((x) => { return { label: x.branch_name, value: x.branch_id } })}
                                                    onChange={(val) => {
                                                        swal("Alert!", "Please verify applicable taxes for selected items", "info")
                                                        setSelectedBranch(val);
                                                        setSelectedTransactionSeries(null)
                                                    }}
                                                    value={selectedBranch}
                                                    placeholder="Select Branch"
                                                    isDisabled
                                                />
                                            </div>
                                            <div className="col-md-4 px-1 mb-2">
                                                <label className="required fs-5 fw-bold mb-2">Transaction Series:</label>
                                                <Select
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    options={selectedBranch != null && transactionSeriesList.filter(x => branchList.find(a => a.branch_id == selectedBranch.value).transaction_series_id.split(",").includes(x.transaction_series_id)).map(x => { return { label: x.series_name, value: x.transaction_series_id } })}
                                                    value={selectedTransactionSeries}
                                                    placeholder="Select Transaction Series"
                                                    isDisabled
                                                />
                                            </div>
                                            <div className="col-md-4 px-1 mb-2">
                                                <label className="fs-5 fw-bold mb-2">Credit Note#</label>
                                                <input type="text" className="form-control form-control-solid" value={creditNoteNumber} readOnly disabled />
                                            </div>
                                        </div>

                                        <div className="row mb-5">
                                            <div className="col-md-6 mb-2">
                                                <label className="fs-5 fw-bold mb-2 required">Organization GSTIN</label>
                                                <Select
                                                    options={organizationGstinList.map(x => { return { label: x.GstIn, value: x.unique_id, legal_name: x.legal_name, trade_name: x.trade_name } })}
                                                    onChange={(val) => { setSelectedOrganizationGstin(val) }}
                                                    value={selectedOrganizationGstin}
                                                    placeholder="Select GSTIN..."
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    components={{
                                                        Option: (props) => {
                                                            return (
                                                                <components.Option  {...props}>
                                                                    <span className='fw-bold'>{props.children}</span>
                                                                    <div className='d-flex justify-content-between'>
                                                                        <span className="fs-6">{props.data.legal_name}</span>
                                                                        <span className="fs-6">{props.data.trade_name}</span>
                                                                    </div>
                                                                </components.Option >
                                                            )
                                                        }
                                                    }}
                                                />
                                                {selectedOrganizationGstin && !organizationGstinList.find(x => x.unique_id === selectedOrganizationGstin.value).branch_list.includes(selectedBranch.value) && <span className='text-danger'>Note: This Gstin No. is not associated to the Current Selected Branch</span>}
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="fs-5 fw-bold mb-2">Select Salesperson</label>
                                                <Select
                                                    options={userList.map(x => { return { label: x.name + " - " + x.user_id, value: x.user_id } })}
                                                    onChange={(val) => { setSelectedUser(val) }}
                                                    value={selectedUser}
                                                    placeholder="Select Salesperson..."
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                //isDisabled={props.match.params.id}
                                                />
                                            </div>
                                        </div>

                                        <div className="row mb-5">
                                            <div className="col-md-4 mb-2">
                                                <label className="fs-5 fw-bold mb-2">Reference Number</label>
                                                <input type="text" className="form-control form-control-solid" value={referenceNumber} onChange={(e) => { setReferenceNumber(e.target.value) }} />
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="fs-5 fw-bold mb-2">Terms</label>
                                                <Select
                                                    options={termsList.map(x => { return { label: x.term_name, value: x.no_of_days } })}
                                                    onChange={(val) => { setSelectedTerm(val); setDueDate(moment.utc(invoiceDate).add(val.value, "days").format('YYYY-MM-DD')); }}
                                                    value={selectedTerm}
                                                    components={{
                                                        MenuList: (props) => {
                                                            return (
                                                                <components.MenuList  {...props}>
                                                                    {props.children}
                                                                    <div className='d-flex justify-content-center'>
                                                                        <button className='btn btn-success rounded btn-sm my-1'
                                                                            onClick={() => {
                                                                                setTermsModalShow(true)
                                                                                setTermsPanelList(termsList.map(x => { return { ...x } }))
                                                                            }}
                                                                        >&#10011; Configure Terms</button>
                                                                    </div>
                                                                </components.MenuList >
                                                            )
                                                        }
                                                    }}

                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                />
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="fs-5 fw-bold mb-2">Reason</label>
                                                <Select
                                                    options={reasonList.map(x => { return { label: x, value: x } })}
                                                    onChange={(val) => { setSelectedReason(val.value) }}
                                                    value={{ label: selectedReason, value: selectedReason }}
                                                    placeholder="Select Reason..."
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                //isDisabled={props.match.params.id}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-12">
                                                <label className="fs-5 fw-bold mb-2">Subject</label>
                                                <textarea className="form-control form-control-solid fs-6" rows="3" value={subject} onChange={(e) => { setSubject(e.target.value) }} placeholder={"Explain the reason for this credit note"} ></textarea>
                                            </div>
                                        </div>
                                        {creditNoteType !== "By Sales Return" &&
                                            <>
                                                <hr />
                                                <div className='' style={{ overflowX: "auto" }}>
                                                    <div className='container' style={{ minWidth: "1000px" }}>
                                                        <div className="row mb-5 gx-0">
                                                            <div className="col-2"><p className="fs-5 text-center">Item</p></div>
                                                            <div className="col"><p className="fs-5 text-center">Rate</p></div>
                                                            <div className="col"><p className="fs-5 text-center">Quantity</p></div>
                                                            <div className="col"><p className="fs-5 text-center">Line Total</p></div>
                                                            <div className="col"></div>
                                                        </div>
                                                        {
                                                            itemArray.length > 0 && itemArray.map((obj, indx, arr) => {
                                                                return (
                                                                    <div key={indx} className="row mb-5 gx-0 align-items-baseline">
                                                                        <div className="col-2 px-0">
                                                                            <Select
                                                                                options={itemList}
                                                                                onChange={(val) => {
                                                                                    if (itemArray.filter(x => ((x.item !== null) && (x.item.value == val.value))).length > 0) {
                                                                                        swal("Oops!", "This product already selected.", "warning");
                                                                                        return
                                                                                    }
                                                                                    let temp = itemArray.map(a => { return { ...a } });
                                                                                    temp[indx].item = val;
                                                                                    const decimal_place = selectedCurrency == null ? 3 : currencyList.find(x => x.currency_id == selectedCurrency.value).decimal_place;
                                                                                    if (creditNoteType == "By Invoice") {
                                                                                        const item = selectedInvoice.item_list.find(x => x.item_id == val.value)
                                                                                        console.log(item);
                                                                                        temp[indx].item_data = [];
                                                                                        temp[indx].quantity_max = item.quantity;
                                                                                        temp[indx].stock_data = [];

                                                                                        temp[indx].item_type = item.item_type
                                                                                        temp[indx].tracking_inventory_type = item.tracking_inventory_type
                                                                                        temp[indx].quantity_unit = item.usage_unit
                                                                                        temp[indx].rate = item.rate
                                                                                        temp[indx].line_total = trimDecimalPlaces((((temp[indx].quantity * item.rate) - (item.discount_type == "amount" ? item.discount_unit : temp[indx].quantity * item.rate * item.discount_unit / 100)) + (item.tax_group_id == null ? 0 : ((temp[indx].quantity * item.rate) - (item.discount_type == "amount" ? item.discount_unit : temp[indx].quantity * item.rate * item.discount_unit / 100)) * (item.tax_group_percentage / 100))), decimal_place);
                                                                                    }
                                                                                    else if (creditNoteType == "Direct") {
                                                                                        let pr_d = allItemList.find(x => x.pid == val.value)
                                                                                        let g_rate = pr_d.price_information === null ? 0 : trimDecimalPlaces((parseFloat((pr_d.price_information.type === "Customer" ? pr_d.price_information.customer_invoice_price : 0))), decimal_place);
                                                                                        let pr_ac = (pr_d.product_details.length > 0 && pr_d.product_details.find(x => selectedBranch.value == x.branch_id && selectedWarehouse.value == x.warehouse_id) !== undefined) ? pr_d.product_details.find(x => selectedBranch.value == x.branch_id && selectedWarehouse.value == x.warehouse_id).available_count : 0;
                                                                                        if (pr_ac <= 0) {
                                                                                            swal("Warning", "No stock available for this product!", "warning");
                                                                                            return
                                                                                        }
                                                                                        temp[indx].item_data = pr_d;
                                                                                        temp[indx].quantity_max = pr_ac;
                                                                                        temp[indx].stock_data = [];
                                                                                        temp[indx].rate = g_rate

                                                                                        temp[indx].item_type = pr_d.product_type
                                                                                        temp[indx].tracking_inventory_type = pr_d.tracking_inventory_type
                                                                                        temp[indx].quantity_unit = pr_d.quantity_unit
                                                                                        temp[indx].line_total = trimDecimalPlaces((temp[indx].quantity * temp[indx].rate), decimal_place)
                                                                                        setTracking_inventory(pr_d.tracking_inventory_type);

                                                                                    }
                                                                                    setItemArray(temp)
                                                                                }}
                                                                                onInputChange={(val) => { (val.length > search_length && creditNoteType == "Direct") && getItems(val); }}
                                                                                onMenuClose={() => { creditNoteType == "Direct" && getItems(null); }}
                                                                                isLoading={itemApiState}
                                                                                value={itemArray[indx].item}
                                                                                menuPosition='fixed'
                                                                                menuShouldBlockScroll={true}
                                                                                components={{
                                                                                    MenuList: (props) => {
                                                                                        return (
                                                                                            <components.MenuList  {...props}>
                                                                                                {props.children}
                                                                                                <div className='d-flex justify-content-center'>
                                                                                                    <button className='btn btn-success rounded btn-sm my-1' onClick={() => { setItemModalShow(true) }} >&#10011; Add New Item</button>
                                                                                                </div>
                                                                                            </components.MenuList >
                                                                                        )
                                                                                    }
                                                                                }}
                                                                                styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                            />
                                                                        </div>
                                                                        <div className="col px-1">
                                                                            <div className="input-group input-group-solid mb-5">
                                                                                <span className="input-group-text">{currencyList.find(x => x.currency_id == selectedCurrency.value).currency_symbol}</span>
                                                                                <input type="number" className="form-control form-control-solid px-2" value={itemArray[indx].rate.toString()}
                                                                                    onChange={(e) => {
                                                                                        let temp = itemArray.map(a => { return { ...a } })
                                                                                        temp[indx].rate = e.target.value == "" ? 0 : trimDecimalPlaces((parseFloat(e.target.value)), selectedCurrency == null ? 3 : currencyList.find(x => x.currency_id == selectedCurrency.value).decimal_place)
                                                                                        temp[indx].line_total = trimDecimalPlaces((temp[indx].quantity * temp[indx].rate), selectedCurrency == null ? 3 : currencyList.find(x => x.currency_id == selectedCurrency.value).decimal_place)
                                                                                        setItemArray(temp)
                                                                                    }}
                                                                                    readOnly={creditNoteType === "By Invoice"}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col px-1">
                                                                            <input type="number" className="form-control form-control-solid px-2" value={itemArray[indx].quantity.toString()}
                                                                                onChange={(e) => {
                                                                                    if (parseFloat(e.target.value) < 0) {
                                                                                        return
                                                                                    }

                                                                                    let temp = itemArray.map(a => { return { ...a } })

                                                                                    if (parseFloat(e.target.value) > temp[indx].quantity_max) {
                                                                                        swal("Maximum quantity reached!", `Max Quantity: ${temp[indx].quantity_max}`, "warning");
                                                                                        return
                                                                                    }

                                                                                    temp[indx].quantity = e.target.value == "" ? 0 : parseFloat(e.target.value);
                                                                                    const decimal_place = selectedCurrency == null ? 3 : currencyList.find(x => x.currency_id == selectedCurrency.value).decimal_place;
                                                                                    if (creditNoteType == "By Invoice") {
                                                                                        const item = selectedInvoice.item_list.find(x => x.item_id == temp[indx].item.value);
                                                                                        temp[indx].line_total = trimDecimalPlaces((((temp[indx].quantity * item.rate) - (item.discount_type == "amount" ? item.discount_unit : temp[indx].quantity * item.rate * item.discount_unit / 100)) + (item.tax_group_id == null ? 0 : ((temp[indx].quantity * item.rate) - (item.discount_type == "amount" ? item.discount_unit : temp[indx].quantity * item.rate * item.discount_unit / 100)) * (item.tax_group_percentage / 100))), decimal_place);
                                                                                    }
                                                                                    else {
                                                                                        temp[indx].line_total = trimDecimalPlaces((temp[indx].quantity * temp[indx].rate), decimal_place)
                                                                                    }

                                                                                    setItemArray(temp)
                                                                                }}
                                                                            />
                                                                            {
                                                                                (creditNoteType === "Direct" && itemArray[indx].item != null && (itemArray[indx].tracking_inventory_type === "Track Serial Number" || itemArray[indx].tracking_inventory_type === "Track Batches")) &&
                                                                                <div className='mt-1'>
                                                                                    <div style={{ position: "relative", display: "inline-block" }} >
                                                                                        <button className='btn p-0 text-hover-primary'
                                                                                            onClick={() => {
                                                                                                setProductId(itemArray[indx].item.value);
                                                                                                setTracking_inventory(itemArray[indx].tracking_inventory_type);
                                                                                                setQuantity_adjust(itemArray[indx].quantity);
                                                                                                setStockData(itemArray[indx].stock_data);
                                                                                                if (itemArray[indx].tracking_inventory_type === "Track Serial Number") {
                                                                                                    setSerialInModalShow(true);
                                                                                                }
                                                                                                else {
                                                                                                    Add_serial_batch_section();
                                                                                                    setBatchInModalShow(true);
                                                                                                }
                                                                                            }}
                                                                                        >Manage Stock<i className="fa fa-pencil ms-1" aria-hidden="true"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                        <div className="col px-1">
                                                                            <div className="input-group input-group-solid mb-5">
                                                                                <span className="input-group-text">{currencyList.find(x => x.currency_id == selectedCurrency.value).currency_symbol}</span>
                                                                                <input type="number" className="form-control form-control-solid px-2" readOnly value={obj.line_total} />
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            arr.length > 1 ?
                                                                                <div className="col position-relative">
                                                                                    <button className='btn btn-sm btn-outline-info rounded-pill border border-info fw-bolder'
                                                                                        onClick={() => {
                                                                                            let temp = itemArray.map(a => { return { ...a } })
                                                                                            temp.splice(indx, 1)
                                                                                            setItemArray(temp)
                                                                                        }}
                                                                                    >&#10006;</button>
                                                                                </div>
                                                                                : <div className="col" style={{ visibility: "hidden" }}></div>
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                        <div className="row mb-5">
                                                            <div className="col-3">
                                                                <button className='btn btn-primary rounded fs-7' onClick={() => { setItemArray([...itemArray, { item: null, item_data: null, stock_data: [], item_type: "", item_code: "", quantity: 1, quantity_unit: null, quantity_max: 0, rate: 0, line_total: 0 }]) }}>&#10011; Add a row</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr />
                                            </>
                                        }
                                        <div className="d-flex flex-stack bg-success rounded-3 p-6 mb-11">
                                            <div className="fs-6 fw-bold text-white">
                                                <span className="d-block lh-1 mb-2">Credit Note Balance</span>
                                            </div>
                                            <div className="fs-6 fw-bold text-white text-end">
                                                <span className="d-block lh-1 mb-2">{currencyList.find(x => x.currency_id == selectedCurrency.value).currency_symbol}&nbsp;{formatNumber(grandTotal, { ...formatNumberOptions, currencyFormat: currencyList.find(x => x.currency_id == selectedCurrency.value).format, decimalPlaces: currencyList.find(x => x.currency_id == selectedCurrency.value).decimal_place })}</span>
                                            </div>
                                        </div>

                                        <div className="row mb-5">
                                            <div className="col-md-6 my-2">
                                                <label className="fs-5 fw-bold mb-2">Customer Notes</label>
                                                <textarea className="form-control form-control-solid" rows="3" value={customerNotes} onChange={(e) => { setCustomerNotes(e.target.value) }} placeholder={"Looking forward for your business."}></textarea>
                                            </div>
                                            <div className="col-md-6 my-2">
                                                <label className="fs-5 fw-bold mb-2">Terms and Conditions</label>
                                                <textarea className="form-control form-control-solid" rows="3" value={termsAndConditions} onChange={(e) => { setTermsAndConditions(e.target.value) }} placeholder={"Enter the terms and conditions of your business to be displayed in your transaction"}></textarea>
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-12 my-2">
                                                <label className="fs-5 fw-bold mb-2">Previously Uploaded Documents</label>
                                                <div className="mb-5 p-5 rounded row gap-2">
                                                    {
                                                        previouslyUploadedDocuments.length === 0 ? <span className='text-center text-gray-600 fs-3'>No files uploaded previously</span> :
                                                            previouslyUploadedDocuments.map((x, i) => {
                                                                return (
                                                                    <div key={i} className="col-md-2 m-2 bg-light-danger border border-danger border-dashed border-2 rounded p-3 d-flex justify-content-between align-items-center">
                                                                        <a title={x.original_filename} className='me-5 fs-5 fw-bold cursor-pointer' href={`${process.env.REACT_APP_GENERAL_IMAGE_BUCKET}/bill_docs/${organization_id}/${x.filename}`}>{x.original_filename.slice(0, 8)}{x.original_filename.length > 8 && "..."}</a>
                                                                        {
                                                                            deleteCreditNoteApiState ?
                                                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                                                :
                                                                                <i
                                                                                    className="bi bi-trash-fill cursor-pointer fs-2 p-0 text-dark text-hover-danger"
                                                                                    onClick={async () => {
                                                                                        let isBillDeleted = await deleteCreditNote(x.filename)

                                                                                        if (isBillDeleted) {
                                                                                            let t = [...previouslyUploadedDocuments]
                                                                                            t.splice(i, 1)
                                                                                            setPreviouslyUploadedDocuments(t)
                                                                                            swal("Alert!", `${x.original_filename} removed successfully`, "info")
                                                                                        }

                                                                                    }}>
                                                                                </i>
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-12 my-2">
                                                <label className="fs-5 fw-bold mb-2">Upload upto {5 - previouslyUploadedDocuments.length} files</label>
                                                <Dropzone multiple={false} maxFiles={5 - previouslyUploadedDocuments.length} maxSize={5 * 1024 * 1024}
                                                    onDrop={acceptedFiles => {
                                                        if (acceptedFiles.length) {
                                                            if (uploadedDocuments.length === 5 - previouslyUploadedDocuments.length) {
                                                                swal("Oops!", "Maximum number of files uploaded already, remove some to add more", "warning");
                                                                return
                                                            }
                                                            if (uploadedDocuments.find(x => x.name === acceptedFiles[0].name)) {
                                                                swal("Oops!", "Duplicate file cannot be uploaded", "warning");
                                                                return
                                                            }

                                                            setUploadedDocuments([...uploadedDocuments, acceptedFiles[0]]);
                                                        }
                                                    }}
                                                >
                                                    {({ getRootProps, getInputProps }) => (
                                                        <section>
                                                            <div {...getRootProps()} className="border border-3 border-dashed border-success fs-1 fw-bold p-15 rounded text-center">
                                                                <input {...getInputProps()} />
                                                                {
                                                                    uploadedDocuments.length === 0 ? <p className='m-0'>Drag 'n' drop some files here, or click to select files</p> :
                                                                        <div className='d-flex gap-5 flex-wrap'>
                                                                            {
                                                                                uploadedDocuments.map((x, i) => {
                                                                                    return (
                                                                                        <div key={i}>
                                                                                            <span className='me-3'>{x.name.slice(0, 15)}{x.name.length > 15 && "..."}</span>
                                                                                            <button className='btn btn-danger rounded-pill px-4 py-2' onClick={(e) => {
                                                                                                e.stopPropagation();

                                                                                                let t = [...uploadedDocuments]
                                                                                                t.splice(i, 1)
                                                                                                setUploadedDocuments(t)
                                                                                            }}>✖</button>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </div>
                                                                }
                                                            </div>
                                                        </section>
                                                    )}
                                                </Dropzone>
                                            </div>
                                        </div>

                                        {
                                            write &&
                                            <button type="button" className="btn btn-lg btn-primary mt-15 mx-3 rounded" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} onClick={() => { validateCreditNote() && existingCreditNoteUpdate(false) }}>
                                                <span className="indicator-label">Save as Draft</span>
                                                <span className="indicator-progress">Please wait...
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                            </button>
                                        }

                                        {
                                            write &&
                                            <button type="button" className="btn btn-lg btn-info mt-15 mx-3 rounded" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} onClick={() => { validateCreditNote() && existingCreditNoteUpdate(true) }}>
                                                <span className="indicator-label">Save</span>
                                                <span className="indicator-progress">Please wait...
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                            </button>
                                        }
                                    </>
                                    :
                                    state == 2 ?
                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                        :
                                        <PageError message={failedPageMessage}>
                                            <Link to={`/credit-note-list`} className="btn btn-sm btn-primary me-3 rounded cursor-pointer">Go to Credit Note List</Link>
                                        </PageError>
                            }
                        </div>
                    </div>

                </div>
            </div>
            <Modal show={SerialInModalShow} onHide={() => { }} dialogClassName="h-modal-75" centered>
                <Modal.Header>
                    <Modal.Title>Add Serial Number(s)</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setSerialInModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-body scroll-y mx-5  pt-0  gap-2">
                        {(Tracking_inventory == "Track Serial Number" && Math.sign(Number(Quantity_adjust)) === 1) &&
                            <>
                                {(stockData.length !== Math.abs(Quantity_adjust)) &&
                                    <>
                                        <div className="mb-6">
                                            <div className="d-flex flex-wrap gap-2 align-items-center mb-2">
                                                <div className="flex-grow-1">
                                                    <input type="text" className="form-control" placeholder="Enter Serial Number" value={SerialName}
                                                        onChange={(e) => {
                                                            setSerialName(e.target.value);
                                                        }}
                                                        // onBlur={(e) => {
                                                        //     if (e.target.value != "") {
                                                        //         let temp_arr = [...stockData];
                                                        //         let new_tag = splitIntoTags(e.target.value);
                                                        //         new_tag = new_tag.map(x => { return { uid: uuid(), serialName: x} });
                                                        //         setSerialName("");
                                                        //         setStockData(temp_arr.concat(new_tag));
                                                        //     }
                                                        // }} 
                                                        id="myInput" />
                                                </div>
                                                <div className="">
                                                    <button onClick={(e) => {
                                                        Add_serial_batch_section();
                                                    }} className="btn btn-sm btn-primary me-3 rounded" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState}>
                                                        <span className="svg-icon svg-icon-2">
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor"></rect>
                                                                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"></rect>
                                                            </svg>
                                                        </span>
                                                        <span className="indicator-label">Add</span>
                                                        <span className="indicator-progress">Please wait...
                                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                                                    <div className="text-muted fs-7"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }

                                {(stockData.length !== Number(Quantity_adjust)) &&
                                    <div className="mb-6">
                                        <button onClick={(e) => { setScannerModalShow(true); }} className="btn btn-sm btn-light d-flex align-items-center px-4">
                                            <div className="text-gray-600 fw-bold">Scan</div>
                                            <span className="svg-icon svg-icon-1 ms-2 me-0">
                                                <svg width="24" height="24" mi-view-box="0 0 1024 1024" viewBox="0 0 1024 1024">
                                                    <g>
                                                        <path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M128 384c23.564 0 42.667-19.103 42.667-42.667v0-170.667h170.667c23.564 0 42.667-19.103 42.667-42.667s-19.103-42.667-42.667-42.667v0h-170.667c-47.128 0-85.333 38.205-85.333 85.333v0 170.667c0 23.564 19.103 42.667 42.667 42.667v0z" mi-fill="inherit" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M128 384c23.564 0 42.667-19.103 42.667-42.667v0-170.667h170.667c23.564 0 42.667-19.103 42.667-42.667s-19.103-42.667-42.667-42.667v0h-170.667c-47.128 0-85.333 38.205-85.333 85.333v0 170.667c0 23.564 19.103 42.667 42.667 42.667v0z" fill="inherit" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                        </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M853.333 85.333h-170.667c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.667 42.667 42.667v0h170.667v170.667c0 23.564 19.103 42.667 42.667 42.667s42.667-19.103 42.667-42.667v0-170.667c0-47.128-38.205-85.333-85.333-85.333v0z" mi-fill="inherit" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M853.333 85.333h-170.667c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.667 42.667 42.667v0h170.667v170.667c0 23.564 19.103 42.667 42.667 42.667s42.667-19.103 42.667-42.667v0-170.667c0-47.128-38.205-85.333-85.333-85.333v0z" fill="inherit" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                        </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M896 640c-23.564 0-42.667 19.103-42.667 42.667v0 170.667h-170.667c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.667 42.667 42.667v0h170.667c47.128 0 85.333-38.205 85.333-85.333v0-170.667c0-23.564-19.103-42.667-42.667-42.667v0z" mi-fill="inherit" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M896 640c-23.564 0-42.667 19.103-42.667 42.667v0 170.667h-170.667c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.667 42.667 42.667v0h170.667c47.128 0 85.333-38.205 85.333-85.333v0-170.667c0-23.564-19.103-42.667-42.667-42.667v0z" fill="inherit" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                        </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M341.333 853.333h-170.667v-170.667c0-23.564-19.103-42.667-42.667-42.667s-42.667 19.103-42.667 42.667v0 170.667c0 47.128 38.205 85.333 85.333 85.333v0h170.667c23.564 0 42.667-19.103 42.667-42.667s-19.103-42.667-42.667-42.667v0z" mi-fill="inherit" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M341.333 853.333h-170.667v-170.667c0-23.564-19.103-42.667-42.667-42.667s-42.667 19.103-42.667 42.667v0 170.667c0 47.128 38.205 85.333 85.333 85.333v0h170.667c23.564 0 42.667-19.103 42.667-42.667s-19.103-42.667-42.667-42.667v0z" fill="inherit" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                        </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M896 469.333h-768c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.667 42.667 42.667v0h768c23.564 0 42.667-19.103 42.667-42.667s-19.103-42.667-42.667-42.667v0z" mi-fill="inherit" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M896 469.333h-768c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.667 42.667 42.667v0h768c23.564 0 42.667-19.103 42.667-42.667s-19.103-42.667-42.667-42.667v0z" fill="inherit" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                        </path>
                                                    </g>
                                                    <g ng-show="pref.showGrid" className="edit-grid ng-hide">
                                                        <g className="hLines"></g>
                                                        <g className="vLines"></g>
                                                    </g>
                                                </svg>
                                            </span>
                                        </button>
                                    </div>
                                }
                                {stockData.length > 0 &&
                                    <>
                                        <h3 class="fw-bold m-0">Selected Serial Number:</h3>
                                        <div className="d-flex align-items-center gap-2 gap-lg-3 flex-wrap">
                                            {stockData.map((obj, index) => {
                                                return (
                                                    <div key={index} className="btn btn-sm btn-light d-flex align-items-center px-2">
                                                        <div className="text-gray-600 fw-bold">{obj.serialName}</div>
                                                        <button type="button" style={{ width: "auto", height: "auto", marginLeft: "1rem" }} onClick={(e) => { Remove_serial_batch_section(index) }} className="btn btn-clean btn-sm btn-icon btn-icon-primary btn-active-light-primary">
                                                            <span className="svg-icon svg-icon-4">
                                                                <svg id="edit-svg" style={{ "width": "30%", "height": "40%" }} mi-view-box="0 0 1024 1024" viewBox="0 0 1024 1024">
                                                                    <rect fill="white" x="0" y="0" mi-width="1024" mi-height="1024" width="1024" height="1024"></rect>
                                                                    <g>
                                                                        <path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M721.349 237.158h-65.154v-104.092c0-28.594-23.264-51.858-51.858-51.858h-184.68c-28.594 0-51.858 23.264-51.858 51.858v104.092h-65.154v-104.092c0-64.52 52.492-117.010 117.012-117.010h184.68c64.52 0 117.012 52.492 117.012 117.010v104.092z" mi-fill="rgb(228, 93, 76)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M721.349 237.158h-65.154v-104.092c0-28.594-23.264-51.858-51.858-51.858h-184.68c-28.594 0-51.858 23.264-51.858 51.858v104.092h-65.154v-104.092c0-64.52 52.492-117.010 117.012-117.010h184.68c64.52 0 117.012 52.492 117.012 117.010v104.092z" fill="rgb(228, 93, 76)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                                        </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M321.107 118.95c0-33.71 14.348-64.118 37.236-85.49-33.392 20.63-55.696 57.556-55.696 99.606v104.092h65.154v-14.116h-46.694v-104.092zM674.657 223.042v-104.092c0-28.594-23.264-51.858-51.858-51.858h-199.882c-27.080 0-49.368 20.87-51.652 47.37 7.494-19.43 26.356-33.254 48.394-33.254h184.678c28.594 0 51.858 23.264 51.858 51.858v104.092h65.154v-14.116c0-0-46.692-0-46.692-0z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M321.107 118.95c0-33.71 14.348-64.118 37.236-85.49-33.392 20.63-55.696 57.556-55.696 99.606v104.092h65.154v-14.116h-46.694v-104.092zM674.657 223.042v-104.092c0-28.594-23.264-51.858-51.858-51.858h-199.882c-27.080 0-49.368 20.87-51.652 47.37 7.494-19.43 26.356-33.254 48.394-33.254h184.678c28.594 0 51.858 23.264 51.858 51.858v104.092h65.154v-14.116c0-0-46.692-0-46.692-0z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.1">
                                                                        </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M916.65 262.053h-809.302l85.632 680.493c4.704 37.372 36.48 65.402 74.148 65.402h489.745c37.664 0 69.444-28.032 74.148-65.402l85.628-680.493z" mi-fill="rgb(164, 168, 171)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M916.65 262.053h-809.302l85.632 680.493c4.704 37.372 36.48 65.402 74.148 65.402h489.745c37.664 0 69.444-28.032 74.148-65.402l85.628-680.493z" fill="rgb(164, 168, 171)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                                        </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M188.438 906.46l4.54 36.082c4.704 37.372 36.482 65.402 74.148 65.402h489.745c37.664 0 69.444-28.032 74.148-65.402l4.54-36.082h-647.121z" mi-fill="rgb(74, 80, 88)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M188.438 906.46l4.54 36.082c4.704 37.372 36.482 65.402 74.148 65.402h489.745c37.664 0 69.444-28.032 74.148-65.402l4.54-36.082h-647.121z" fill="rgb(74, 80, 88)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                                        </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M916.648 262.053h-809.3l85.632 680.493c4.704 37.372 36.48 65.402 74.148 65.402h489.745c29.724 0 55.772-17.464 67.748-43.194v0c-9.622 4.49-20.32 6.998-31.552 6.998h-489.745c-37.664 0-69.444-28.032-74.148-65.402l-66.38-527.495h739.153l14.698-116.802z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M916.648 262.053h-809.3l85.632 680.493c4.704 37.372 36.48 65.402 74.148 65.402h489.745c29.724 0 55.772-17.464 67.748-43.194v0c-9.622 4.49-20.32 6.998-31.552 6.998h-489.745c-37.664 0-69.444-28.032-74.148-65.402l-66.38-527.495h739.153l14.698-116.802z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.1">
                                                                        </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M934 155.83h-844.002c-24.478 0-44.322 19.844-44.322 44.322v87.040c0 24.48 19.844 44.322 44.322 44.322h844.002c24.48 0 44.322-19.844 44.322-44.322v-87.040c0-24.476-19.844-44.322-44.322-44.322z" mi-fill="rgb(74, 80, 88)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M934 155.83h-844.002c-24.478 0-44.322 19.844-44.322 44.322v87.040c0 24.48 19.844 44.322 44.322 44.322h844.002c24.48 0 44.322-19.844 44.322-44.322v-87.040c0-24.476-19.844-44.322-44.322-44.322z" fill="rgb(74, 80, 88)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                                        </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M963.172 301.701h-848.168c-21.822 0-39.514-17.692-39.514-39.514v-91.204c0-4.588 0.696-9.008 1.972-13.178-18.402 5.634-31.786 22.746-31.786 42.994v85.754c0 24.832 20.132 44.964 44.964 44.964h842.718c20.248 0 37.358-13.386 42.994-31.786-4.172 1.274-8.594 1.97-13.18 1.97z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.2" ng-click="selectPath($index)" mi-absorb-clicks="" d="M963.172 301.701h-848.168c-21.822 0-39.514-17.692-39.514-39.514v-91.204c0-4.588 0.696-9.008 1.972-13.178-18.402 5.634-31.786 22.746-31.786 42.994v85.754c0 24.832 20.132 44.964 44.964 44.964h842.718c20.248 0 37.358-13.386 42.994-31.786-4.172 1.274-8.594 1.97-13.18 1.97z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.2">
                                                                        </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M511.999 850.458c-17.734 0-32.112-14.378-32.112-32.112v-352.279c0-17.734 14.378-32.112 32.112-32.112s32.112 14.378 32.112 32.112v352.277c0 17.738-14.376 32.114-32.112 32.114z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.2" ng-click="selectPath($index)" mi-absorb-clicks="" d="M511.999 850.458c-17.734 0-32.112-14.378-32.112-32.112v-352.279c0-17.734 14.378-32.112 32.112-32.112s32.112 14.378 32.112 32.112v352.277c0 17.738-14.376 32.114-32.112 32.114z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.2">
                                                                        </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M320.845 850.46c-15.95 0-29.78-11.872-31.82-28.11l-44.266-352.277c-2.212-17.598 10.26-33.652 27.858-35.864 17.614-2.23 33.652 10.26 35.864 27.858l44.266 352.277c2.212 17.598-10.26 33.652-27.858 35.864-1.362 0.17-2.712 0.252-4.044 0.252z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.2" ng-click="selectPath($index)" mi-absorb-clicks="" d="M320.845 850.46c-15.95 0-29.78-11.872-31.82-28.11l-44.266-352.277c-2.212-17.598 10.26-33.652 27.858-35.864 17.614-2.23 33.652 10.26 35.864 27.858l44.266 352.277c2.212 17.598-10.26 33.652-27.858 35.864-1.362 0.17-2.712 0.252-4.044 0.252z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.2">
                                                                        </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M703.155 850.46c-1.334 0-2.684-0.084-4.044-0.254-17.598-2.212-30.070-18.268-27.858-35.864l44.266-352.277c2.212-17.598 18.29-30.068 35.864-27.858 17.598 2.212 30.070 18.268 27.858 35.864l-44.266 352.277c-2.040 16.238-15.87 28.112-31.82 28.112z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.2" ng-click="selectPath($index)" mi-absorb-clicks="" d="M703.155 850.46c-1.334 0-2.684-0.084-4.044-0.254-17.598-2.212-30.070-18.268-27.858-35.864l44.266-352.277c2.212-17.598 18.29-30.068 35.864-27.858 17.598 2.212 30.070 18.268 27.858 35.864l-44.266 352.277c-2.040 16.238-15.87 28.112-31.82 28.112z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.2">
                                                                        </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M934 139.778h-196.592v-6.71c-0-73.374-59.694-133.068-133.070-133.068h-184.68c-73.372 0-133.068 59.694-133.068 133.066v6.71h-196.588c-33.294 0-60.378 27.086-60.378 60.378v87.040c0 33.294 27.084 60.378 60.378 60.378h11.928l75.12 596.975c5.7 45.296 44.428 79.452 90.080 79.452h489.745c45.652 0 84.378-34.158 90.080-79.452l75.12-596.975h11.928c33.294 0 60.378-27.086 60.378-60.378v-87.038c-0.002-33.294-27.090-60.378-60.38-60.378zM318.703 133.066c0-55.666 45.288-100.954 100.956-100.954h184.678c55.668 0 100.956 45.288 100.956 100.954v6.71h-33.042v-6.71c0-37.448-30.466-67.914-67.916-67.914h-184.68c-37.448 0-67.916 30.466-67.916 67.914v6.71h-33.042v-6.71h0.006zM640.141 133.066v6.71h-256.287v-6.71c0-19.74 16.062-35.802 35.804-35.802h184.678c19.742 0.002 35.804 16.062 35.804 35.802zM815.090 940.54c-3.684 29.274-28.714 51.35-58.218 51.35h-489.743c-29.504 0-54.536-22.078-58.218-51.35l-74.618-592.969h755.411l-74.614 592.969zM962.266 287.193c0 15.586-12.68 28.266-28.266 28.266h-844c-15.586 0-28.266-12.68-28.266-28.266v-87.038c0-15.586 12.68-28.266 28.266-28.266h844c15.586 0 28.266 12.68 28.266 28.266v87.038zM697.101 866.136c2.002 0.252 4.038 0.382 6.052 0.382 24.204 0 44.732-18.128 47.752-42.164l44.266-352.277c1.606-12.766-1.858-25.392-9.752-35.554s-19.27-16.64-32.032-18.244c-12.77-1.6-25.384 1.858-35.544 9.75-10.166 7.896-16.65 19.272-18.254 32.036l-44.266 352.277c-1.606 12.766 1.858 25.392 9.752 35.554 7.892 10.158 19.268 16.638 32.026 18.24zM687.185 816.346l44.266-352.277c0.536-4.252 2.698-8.046 6.088-10.676 2.848-2.212 6.272-3.38 9.814-3.38 0.672 0 1.352 0.042 2.032 0.126 4.254 0.536 8.048 2.696 10.676 6.082 2.632 3.386 3.788 7.596 3.252 11.852l-44.266 352.277c-1.094 8.69-9.15 15.030-17.934 13.928-4.254-0.536-8.048-2.696-10.676-6.082-2.632-3.388-3.786-7.596-3.252-11.85zM273.093 824.352c3.020 24.036 23.548 42.164 47.752 42.164 2.014 0 4.052-0.128 6.044-0.378 12.768-1.604 24.144-8.082 32.036-18.244 7.89-10.16 11.356-22.788 9.752-35.552l-44.266-352.279c-1.606-12.766-8.080-24.144-18.232-32.036-10.166-7.904-22.806-11.368-35.562-9.75-12.768 1.604-24.144 8.082-32.036 18.244-7.894 10.162-11.356 22.788-9.752 35.552l44.264 352.279zM263.937 456.221c2.63-3.386 6.422-5.546 10.694-6.084 0.682-0.086 1.366-0.128 2.044-0.128 3.536 0 6.954 1.164 9.792 3.372 3.384 2.632 5.544 6.428 6.080 10.688l44.266 352.279c0.536 4.254-0.618 8.462-3.252 11.85-2.632 3.386-6.422 5.546-10.684 6.082-0.672 0.084-1.358 0.128-2.034 0.128-8.054 0-14.882-6.044-15.89-14.056l-44.266-352.279c-0.536-4.258 0.618-8.466 3.25-11.852zM511.999 866.514c26.558 0 48.168-21.606 48.168-48.168v-352.279c0-26.56-21.608-48.168-48.168-48.168s-48.168 21.606-48.168 48.168v352.277c0.002 26.562 21.608 48.17 48.168 48.17zM495.945 466.067c0-8.854 7.202-16.056 16.056-16.056s16.056 7.202 16.056 16.056v352.277c0 8.854-7.202 16.056-16.056 16.056s-16.056-7.202-16.056-16.056v-352.277z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M934 139.778h-196.592v-6.71c-0-73.374-59.694-133.068-133.070-133.068h-184.68c-73.372 0-133.068 59.694-133.068 133.066v6.71h-196.588c-33.294 0-60.378 27.086-60.378 60.378v87.040c0 33.294 27.084 60.378 60.378 60.378h11.928l75.12 596.975c5.7 45.296 44.428 79.452 90.080 79.452h489.745c45.652 0 84.378-34.158 90.080-79.452l75.12-596.975h11.928c33.294 0 60.378-27.086 60.378-60.378v-87.038c-0.002-33.294-27.090-60.378-60.38-60.378zM318.703 133.066c0-55.666 45.288-100.954 100.956-100.954h184.678c55.668 0 100.956 45.288 100.956 100.954v6.71h-33.042v-6.71c0-37.448-30.466-67.914-67.916-67.914h-184.68c-37.448 0-67.916 30.466-67.916 67.914v6.71h-33.042v-6.71h0.006zM640.141 133.066v6.71h-256.287v-6.71c0-19.74 16.062-35.802 35.804-35.802h184.678c19.742 0.002 35.804 16.062 35.804 35.802zM815.090 940.54c-3.684 29.274-28.714 51.35-58.218 51.35h-489.743c-29.504 0-54.536-22.078-58.218-51.35l-74.618-592.969h755.411l-74.614 592.969zM962.266 287.193c0 15.586-12.68 28.266-28.266 28.266h-844c-15.586 0-28.266-12.68-28.266-28.266v-87.038c0-15.586 12.68-28.266 28.266-28.266h844c15.586 0 28.266 12.68 28.266 28.266v87.038zM697.101 866.136c2.002 0.252 4.038 0.382 6.052 0.382 24.204 0 44.732-18.128 47.752-42.164l44.266-352.277c1.606-12.766-1.858-25.392-9.752-35.554s-19.27-16.64-32.032-18.244c-12.77-1.6-25.384 1.858-35.544 9.75-10.166 7.896-16.65 19.272-18.254 32.036l-44.266 352.277c-1.606 12.766 1.858 25.392 9.752 35.554 7.892 10.158 19.268 16.638 32.026 18.24zM687.185 816.346l44.266-352.277c0.536-4.252 2.698-8.046 6.088-10.676 2.848-2.212 6.272-3.38 9.814-3.38 0.672 0 1.352 0.042 2.032 0.126 4.254 0.536 8.048 2.696 10.676 6.082 2.632 3.386 3.788 7.596 3.252 11.852l-44.266 352.277c-1.094 8.69-9.15 15.030-17.934 13.928-4.254-0.536-8.048-2.696-10.676-6.082-2.632-3.388-3.786-7.596-3.252-11.85zM273.093 824.352c3.020 24.036 23.548 42.164 47.752 42.164 2.014 0 4.052-0.128 6.044-0.378 12.768-1.604 24.144-8.082 32.036-18.244 7.89-10.16 11.356-22.788 9.752-35.552l-44.266-352.279c-1.606-12.766-8.080-24.144-18.232-32.036-10.166-7.904-22.806-11.368-35.562-9.75-12.768 1.604-24.144 8.082-32.036 18.244-7.894 10.162-11.356 22.788-9.752 35.552l44.264 352.279zM263.937 456.221c2.63-3.386 6.422-5.546 10.694-6.084 0.682-0.086 1.366-0.128 2.044-0.128 3.536 0 6.954 1.164 9.792 3.372 3.384 2.632 5.544 6.428 6.080 10.688l44.266 352.279c0.536 4.254-0.618 8.462-3.252 11.85-2.632 3.386-6.422 5.546-10.684 6.082-0.672 0.084-1.358 0.128-2.034 0.128-8.054 0-14.882-6.044-15.89-14.056l-44.266-352.279c-0.536-4.258 0.618-8.466 3.25-11.852zM511.999 866.514c26.558 0 48.168-21.606 48.168-48.168v-352.279c0-26.56-21.608-48.168-48.168-48.168s-48.168 21.606-48.168 48.168v352.277c0.002 26.562 21.608 48.17 48.168 48.17zM495.945 466.067c0-8.854 7.202-16.056 16.056-16.056s16.056 7.202 16.056 16.056v352.277c0 8.854-7.202 16.056-16.056 16.056s-16.056-7.202-16.056-16.056v-352.277z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                                        </path>
                                                                    </g>
                                                                    <g ng-show="pref.showGrid" className="edit-grid ng-hide">
                                                                        <g className="hLines"></g>
                                                                        <g className="vLines"></g>
                                                                    </g>
                                                                </svg>
                                                            </span>
                                                        </button>
                                                    </div>
                                                )
                                            })
                                            }
                                        </div>
                                    </>
                                }
                            </>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { reset_serial_batch_section(); }} className="btn btn-warning" data-bs-dismiss="modal">Reset</button>
                    <button type="button" onClick={(e) => { setSerialInModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    {stockData.length > 0 && <button type="button" onClick={(e) => { stockValidationCheck(productId) && setSerialInModalShow(false) }} className="btn btn-success" data-bs-dismiss="modal">Save</button>}
                </Modal.Footer>
            </Modal>

            <Modal show={ScannerModalShow} onHide={() => { setScannerModalShow(false); }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Scan Serial Number</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setScannerModalShow(false); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container px-1'>
                        <div className='row align-items-center mt-5'>
                            <div className='col-md-5 mt-5 mt-md-0'>
                                <div className='mx-auto'>
                                    <BarcodeScannerComponent
                                        width={350}
                                        height={350}
                                        onUpdate={capture}
                                        videoConstraints={{
                                            width: 1280,
                                            height: 720,
                                            facingMode: selectedCamera == "user" ? selectedCamera : { exact: selectedCamera }
                                        }}
                                    />
                                    {Selected_multiple_serial.length > 0 &&
                                        <>
                                            <h3 className="fw-bold m-0">Selected Serial Number:</h3>
                                            <div className="d-flex align-items-center gap-2 gap-lg-3 flex-wrap">
                                                {Selected_multiple_serial.map((obj, index) => {
                                                    return (
                                                        <div key={index} className="btn btn-sm btn-light d-flex align-items-center px-2">
                                                            <div className="text-gray-600 fw-bold">{obj.serialName}</div>
                                                            <button type="button" style={{ width: "auto", height: "auto", marginLeft: "1rem" }} onClick={(e) => { Remove_multiple_scan_serial(index) }} className="btn btn-clean btn-sm btn-icon btn-icon-primary btn-active-light-primary">
                                                                <span className="svg-icon svg-icon-4">
                                                                    <svg id="edit-svg" style={{ "width": "30%", "height": "40%" }} mi-view-box="0 0 1024 1024" viewBox="0 0 1024 1024">
                                                                        <rect fill="white" x="0" y="0" mi-width="1024" mi-height="1024" width="1024" height="1024"></rect>
                                                                        <g>
                                                                            <path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M721.349 237.158h-65.154v-104.092c0-28.594-23.264-51.858-51.858-51.858h-184.68c-28.594 0-51.858 23.264-51.858 51.858v104.092h-65.154v-104.092c0-64.52 52.492-117.010 117.012-117.010h184.68c64.52 0 117.012 52.492 117.012 117.010v104.092z" mi-fill="rgb(228, 93, 76)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M721.349 237.158h-65.154v-104.092c0-28.594-23.264-51.858-51.858-51.858h-184.68c-28.594 0-51.858 23.264-51.858 51.858v104.092h-65.154v-104.092c0-64.52 52.492-117.010 117.012-117.010h184.68c64.52 0 117.012 52.492 117.012 117.010v104.092z" fill="rgb(228, 93, 76)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M321.107 118.95c0-33.71 14.348-64.118 37.236-85.49-33.392 20.63-55.696 57.556-55.696 99.606v104.092h65.154v-14.116h-46.694v-104.092zM674.657 223.042v-104.092c0-28.594-23.264-51.858-51.858-51.858h-199.882c-27.080 0-49.368 20.87-51.652 47.37 7.494-19.43 26.356-33.254 48.394-33.254h184.678c28.594 0 51.858 23.264 51.858 51.858v104.092h65.154v-14.116c0-0-46.692-0-46.692-0z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M321.107 118.95c0-33.71 14.348-64.118 37.236-85.49-33.392 20.63-55.696 57.556-55.696 99.606v104.092h65.154v-14.116h-46.694v-104.092zM674.657 223.042v-104.092c0-28.594-23.264-51.858-51.858-51.858h-199.882c-27.080 0-49.368 20.87-51.652 47.37 7.494-19.43 26.356-33.254 48.394-33.254h184.678c28.594 0 51.858 23.264 51.858 51.858v104.092h65.154v-14.116c0-0-46.692-0-46.692-0z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.1">
                                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M916.65 262.053h-809.302l85.632 680.493c4.704 37.372 36.48 65.402 74.148 65.402h489.745c37.664 0 69.444-28.032 74.148-65.402l85.628-680.493z" mi-fill="rgb(164, 168, 171)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M916.65 262.053h-809.302l85.632 680.493c4.704 37.372 36.48 65.402 74.148 65.402h489.745c37.664 0 69.444-28.032 74.148-65.402l85.628-680.493z" fill="rgb(164, 168, 171)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M188.438 906.46l4.54 36.082c4.704 37.372 36.482 65.402 74.148 65.402h489.745c37.664 0 69.444-28.032 74.148-65.402l4.54-36.082h-647.121z" mi-fill="rgb(74, 80, 88)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M188.438 906.46l4.54 36.082c4.704 37.372 36.482 65.402 74.148 65.402h489.745c37.664 0 69.444-28.032 74.148-65.402l4.54-36.082h-647.121z" fill="rgb(74, 80, 88)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M916.648 262.053h-809.3l85.632 680.493c4.704 37.372 36.48 65.402 74.148 65.402h489.745c29.724 0 55.772-17.464 67.748-43.194v0c-9.622 4.49-20.32 6.998-31.552 6.998h-489.745c-37.664 0-69.444-28.032-74.148-65.402l-66.38-527.495h739.153l14.698-116.802z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M916.648 262.053h-809.3l85.632 680.493c4.704 37.372 36.48 65.402 74.148 65.402h489.745c29.724 0 55.772-17.464 67.748-43.194v0c-9.622 4.49-20.32 6.998-31.552 6.998h-489.745c-37.664 0-69.444-28.032-74.148-65.402l-66.38-527.495h739.153l14.698-116.802z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.1">
                                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M934 155.83h-844.002c-24.478 0-44.322 19.844-44.322 44.322v87.040c0 24.48 19.844 44.322 44.322 44.322h844.002c24.48 0 44.322-19.844 44.322-44.322v-87.040c0-24.476-19.844-44.322-44.322-44.322z" mi-fill="rgb(74, 80, 88)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M934 155.83h-844.002c-24.478 0-44.322 19.844-44.322 44.322v87.040c0 24.48 19.844 44.322 44.322 44.322h844.002c24.48 0 44.322-19.844 44.322-44.322v-87.040c0-24.476-19.844-44.322-44.322-44.322z" fill="rgb(74, 80, 88)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M963.172 301.701h-848.168c-21.822 0-39.514-17.692-39.514-39.514v-91.204c0-4.588 0.696-9.008 1.972-13.178-18.402 5.634-31.786 22.746-31.786 42.994v85.754c0 24.832 20.132 44.964 44.964 44.964h842.718c20.248 0 37.358-13.386 42.994-31.786-4.172 1.274-8.594 1.97-13.18 1.97z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.2" ng-click="selectPath($index)" mi-absorb-clicks="" d="M963.172 301.701h-848.168c-21.822 0-39.514-17.692-39.514-39.514v-91.204c0-4.588 0.696-9.008 1.972-13.178-18.402 5.634-31.786 22.746-31.786 42.994v85.754c0 24.832 20.132 44.964 44.964 44.964h842.718c20.248 0 37.358-13.386 42.994-31.786-4.172 1.274-8.594 1.97-13.18 1.97z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.2">
                                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M511.999 850.458c-17.734 0-32.112-14.378-32.112-32.112v-352.279c0-17.734 14.378-32.112 32.112-32.112s32.112 14.378 32.112 32.112v352.277c0 17.738-14.376 32.114-32.112 32.114z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.2" ng-click="selectPath($index)" mi-absorb-clicks="" d="M511.999 850.458c-17.734 0-32.112-14.378-32.112-32.112v-352.279c0-17.734 14.378-32.112 32.112-32.112s32.112 14.378 32.112 32.112v352.277c0 17.738-14.376 32.114-32.112 32.114z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.2">
                                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M320.845 850.46c-15.95 0-29.78-11.872-31.82-28.11l-44.266-352.277c-2.212-17.598 10.26-33.652 27.858-35.864 17.614-2.23 33.652 10.26 35.864 27.858l44.266 352.277c2.212 17.598-10.26 33.652-27.858 35.864-1.362 0.17-2.712 0.252-4.044 0.252z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.2" ng-click="selectPath($index)" mi-absorb-clicks="" d="M320.845 850.46c-15.95 0-29.78-11.872-31.82-28.11l-44.266-352.277c-2.212-17.598 10.26-33.652 27.858-35.864 17.614-2.23 33.652 10.26 35.864 27.858l44.266 352.277c2.212 17.598-10.26 33.652-27.858 35.864-1.362 0.17-2.712 0.252-4.044 0.252z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.2">
                                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M703.155 850.46c-1.334 0-2.684-0.084-4.044-0.254-17.598-2.212-30.070-18.268-27.858-35.864l44.266-352.277c2.212-17.598 18.29-30.068 35.864-27.858 17.598 2.212 30.070 18.268 27.858 35.864l-44.266 352.277c-2.040 16.238-15.87 28.112-31.82 28.112z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.2" ng-click="selectPath($index)" mi-absorb-clicks="" d="M703.155 850.46c-1.334 0-2.684-0.084-4.044-0.254-17.598-2.212-30.070-18.268-27.858-35.864l44.266-352.277c2.212-17.598 18.29-30.068 35.864-27.858 17.598 2.212 30.070 18.268 27.858 35.864l-44.266 352.277c-2.040 16.238-15.87 28.112-31.82 28.112z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.2">
                                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M934 139.778h-196.592v-6.71c-0-73.374-59.694-133.068-133.070-133.068h-184.68c-73.372 0-133.068 59.694-133.068 133.066v6.71h-196.588c-33.294 0-60.378 27.086-60.378 60.378v87.040c0 33.294 27.084 60.378 60.378 60.378h11.928l75.12 596.975c5.7 45.296 44.428 79.452 90.080 79.452h489.745c45.652 0 84.378-34.158 90.080-79.452l75.12-596.975h11.928c33.294 0 60.378-27.086 60.378-60.378v-87.038c-0.002-33.294-27.090-60.378-60.38-60.378zM318.703 133.066c0-55.666 45.288-100.954 100.956-100.954h184.678c55.668 0 100.956 45.288 100.956 100.954v6.71h-33.042v-6.71c0-37.448-30.466-67.914-67.916-67.914h-184.68c-37.448 0-67.916 30.466-67.916 67.914v6.71h-33.042v-6.71h0.006zM640.141 133.066v6.71h-256.287v-6.71c0-19.74 16.062-35.802 35.804-35.802h184.678c19.742 0.002 35.804 16.062 35.804 35.802zM815.090 940.54c-3.684 29.274-28.714 51.35-58.218 51.35h-489.743c-29.504 0-54.536-22.078-58.218-51.35l-74.618-592.969h755.411l-74.614 592.969zM962.266 287.193c0 15.586-12.68 28.266-28.266 28.266h-844c-15.586 0-28.266-12.68-28.266-28.266v-87.038c0-15.586 12.68-28.266 28.266-28.266h844c15.586 0 28.266 12.68 28.266 28.266v87.038zM697.101 866.136c2.002 0.252 4.038 0.382 6.052 0.382 24.204 0 44.732-18.128 47.752-42.164l44.266-352.277c1.606-12.766-1.858-25.392-9.752-35.554s-19.27-16.64-32.032-18.244c-12.77-1.6-25.384 1.858-35.544 9.75-10.166 7.896-16.65 19.272-18.254 32.036l-44.266 352.277c-1.606 12.766 1.858 25.392 9.752 35.554 7.892 10.158 19.268 16.638 32.026 18.24zM687.185 816.346l44.266-352.277c0.536-4.252 2.698-8.046 6.088-10.676 2.848-2.212 6.272-3.38 9.814-3.38 0.672 0 1.352 0.042 2.032 0.126 4.254 0.536 8.048 2.696 10.676 6.082 2.632 3.386 3.788 7.596 3.252 11.852l-44.266 352.277c-1.094 8.69-9.15 15.030-17.934 13.928-4.254-0.536-8.048-2.696-10.676-6.082-2.632-3.388-3.786-7.596-3.252-11.85zM273.093 824.352c3.020 24.036 23.548 42.164 47.752 42.164 2.014 0 4.052-0.128 6.044-0.378 12.768-1.604 24.144-8.082 32.036-18.244 7.89-10.16 11.356-22.788 9.752-35.552l-44.266-352.279c-1.606-12.766-8.080-24.144-18.232-32.036-10.166-7.904-22.806-11.368-35.562-9.75-12.768 1.604-24.144 8.082-32.036 18.244-7.894 10.162-11.356 22.788-9.752 35.552l44.264 352.279zM263.937 456.221c2.63-3.386 6.422-5.546 10.694-6.084 0.682-0.086 1.366-0.128 2.044-0.128 3.536 0 6.954 1.164 9.792 3.372 3.384 2.632 5.544 6.428 6.080 10.688l44.266 352.279c0.536 4.254-0.618 8.462-3.252 11.85-2.632 3.386-6.422 5.546-10.684 6.082-0.672 0.084-1.358 0.128-2.034 0.128-8.054 0-14.882-6.044-15.89-14.056l-44.266-352.279c-0.536-4.258 0.618-8.466 3.25-11.852zM511.999 866.514c26.558 0 48.168-21.606 48.168-48.168v-352.279c0-26.56-21.608-48.168-48.168-48.168s-48.168 21.606-48.168 48.168v352.277c0.002 26.562 21.608 48.17 48.168 48.17zM495.945 466.067c0-8.854 7.202-16.056 16.056-16.056s16.056 7.202 16.056 16.056v352.277c0 8.854-7.202 16.056-16.056 16.056s-16.056-7.202-16.056-16.056v-352.277z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M934 139.778h-196.592v-6.71c-0-73.374-59.694-133.068-133.070-133.068h-184.68c-73.372 0-133.068 59.694-133.068 133.066v6.71h-196.588c-33.294 0-60.378 27.086-60.378 60.378v87.040c0 33.294 27.084 60.378 60.378 60.378h11.928l75.12 596.975c5.7 45.296 44.428 79.452 90.080 79.452h489.745c45.652 0 84.378-34.158 90.080-79.452l75.12-596.975h11.928c33.294 0 60.378-27.086 60.378-60.378v-87.038c-0.002-33.294-27.090-60.378-60.38-60.378zM318.703 133.066c0-55.666 45.288-100.954 100.956-100.954h184.678c55.668 0 100.956 45.288 100.956 100.954v6.71h-33.042v-6.71c0-37.448-30.466-67.914-67.916-67.914h-184.68c-37.448 0-67.916 30.466-67.916 67.914v6.71h-33.042v-6.71h0.006zM640.141 133.066v6.71h-256.287v-6.71c0-19.74 16.062-35.802 35.804-35.802h184.678c19.742 0.002 35.804 16.062 35.804 35.802zM815.090 940.54c-3.684 29.274-28.714 51.35-58.218 51.35h-489.743c-29.504 0-54.536-22.078-58.218-51.35l-74.618-592.969h755.411l-74.614 592.969zM962.266 287.193c0 15.586-12.68 28.266-28.266 28.266h-844c-15.586 0-28.266-12.68-28.266-28.266v-87.038c0-15.586 12.68-28.266 28.266-28.266h844c15.586 0 28.266 12.68 28.266 28.266v87.038zM697.101 866.136c2.002 0.252 4.038 0.382 6.052 0.382 24.204 0 44.732-18.128 47.752-42.164l44.266-352.277c1.606-12.766-1.858-25.392-9.752-35.554s-19.27-16.64-32.032-18.244c-12.77-1.6-25.384 1.858-35.544 9.75-10.166 7.896-16.65 19.272-18.254 32.036l-44.266 352.277c-1.606 12.766 1.858 25.392 9.752 35.554 7.892 10.158 19.268 16.638 32.026 18.24zM687.185 816.346l44.266-352.277c0.536-4.252 2.698-8.046 6.088-10.676 2.848-2.212 6.272-3.38 9.814-3.38 0.672 0 1.352 0.042 2.032 0.126 4.254 0.536 8.048 2.696 10.676 6.082 2.632 3.386 3.788 7.596 3.252 11.852l-44.266 352.277c-1.094 8.69-9.15 15.030-17.934 13.928-4.254-0.536-8.048-2.696-10.676-6.082-2.632-3.388-3.786-7.596-3.252-11.85zM273.093 824.352c3.020 24.036 23.548 42.164 47.752 42.164 2.014 0 4.052-0.128 6.044-0.378 12.768-1.604 24.144-8.082 32.036-18.244 7.89-10.16 11.356-22.788 9.752-35.552l-44.266-352.279c-1.606-12.766-8.080-24.144-18.232-32.036-10.166-7.904-22.806-11.368-35.562-9.75-12.768 1.604-24.144 8.082-32.036 18.244-7.894 10.162-11.356 22.788-9.752 35.552l44.264 352.279zM263.937 456.221c2.63-3.386 6.422-5.546 10.694-6.084 0.682-0.086 1.366-0.128 2.044-0.128 3.536 0 6.954 1.164 9.792 3.372 3.384 2.632 5.544 6.428 6.080 10.688l44.266 352.279c0.536 4.254-0.618 8.462-3.252 11.85-2.632 3.386-6.422 5.546-10.684 6.082-0.672 0.084-1.358 0.128-2.034 0.128-8.054 0-14.882-6.044-15.89-14.056l-44.266-352.279c-0.536-4.258 0.618-8.466 3.25-11.852zM511.999 866.514c26.558 0 48.168-21.606 48.168-48.168v-352.279c0-26.56-21.608-48.168-48.168-48.168s-48.168 21.606-48.168 48.168v352.277c0.002 26.562 21.608 48.17 48.168 48.17zM495.945 466.067c0-8.854 7.202-16.056 16.056-16.056s16.056 7.202 16.056 16.056v352.277c0 8.854-7.202 16.056-16.056 16.056s-16.056-7.202-16.056-16.056v-352.277z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                                            </path>
                                                                        </g>
                                                                        <g ng-show="pref.showGrid" className="edit-grid ng-hide">
                                                                            <g className="hLines"></g>
                                                                            <g className="vLines"></g>
                                                                        </g>
                                                                    </svg>
                                                                </span>
                                                            </button>
                                                        </div>
                                                    )
                                                })
                                                }
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>

                            <div className='col-md-2 row mt-5 px-5' style={{ zIndex: 1 }} >
                                <div className='col-3 col-md-12 d-flex align-items-center'>
                                    <button className="btn rounded-pill" onClick={() => { selectedCamera == "user" ? setSelectedCamera("environment") : setSelectedCamera("user") }}>
                                        <svg version="1.1" width="32" height="32" viewBox="0 0 1000 1000">
                                            <g transform="translate(0.000000,380.000000) scale(0.100000,-0.100000)">
                                                <path d="M3257.7,2389.6c-99.6-51.7-227.8-197.2-390.6-444.2c-225.9-340.8-55.5-300.6-1294.3-306.3l-1062.6-5.7l-103.4-57.4c-59.4-32.5-135.9-97.6-178.1-149.3c-139.8-178.1-132.1,19.1-126.4-3049.9l5.7-2755.1l40.2-88.1c88.1-189.6,247-308.3,461.4-342.7c149.3-24.9,8630.9-24.9,8780.3,0c214.4,34.5,373.3,153.2,461.4,342.7l40.2,88.1l5.7,2755.1c5.7,3069.1,13.4,2871.9-126.3,3049.9c-42.1,51.7-118.7,116.8-178,149.3l-103.4,57.4l-1062.6,5.7c-1238.7,5.8-1068.3-34.5-1294.3,306.3c-166.6,250.8-291,394.4-394.4,446.1c-68.9,34.5-135.9,36.4-1742.3,36.4C3403.2,2426,3320.9,2424.1,3257.7,2389.6z M6621.7,1983.7c30.6-34.5,128.3-168.5,214.4-296.8c162.7-243.1,268-354.2,377.2-400.1c51.7-21.1,254.6-26.8,1102.8-26.8c999.4,0,1041.5-1.9,1100.9-38.3c34.5-21.1,68.9-61.3,76.6-90c9.6-28.7,15.3-1259.8,15.3-2734c0-2552.1-1.9-2684.3-34.5-2734c-19.1-30.6-55.5-61.3-82.3-70.8c-65.1-24.9-8719-24.9-8784.1,0c-26.8,9.6-63.2,40.2-82.3,70.8c-32.5,49.8-34.5,181.9-34.5,2734c0,1474.2,5.7,2705.3,15.3,2734c7.7,28.7,42.1,68.9,76.6,90c59.4,36.4,101.5,38.3,1100.9,38.3c848.2,0,1051.1,5.7,1102.8,26.8c109.1,45.9,214.4,157,377.2,400.1c86.2,128.3,183.8,262.3,214.4,296.8l59.4,61.3H5000h1562.3L6621.7,1983.7z"></path>
                                                <path d="M4779.8,461.6c-254.6-30.6-538-126.4-758.2-256.6C3870.4,117,3832.1,71,3832.1-24.7c0-91.9,59.4-164.7,145.5-181.9c55.5-9.6,99.5,3.8,281.4,93.8c292.9,145.5,381,168.5,673.9,180c210.6,7.7,275.7,3.8,421.2-30.6c492.1-118.7,896-459.5,1089.4-917.1c47.9-113,88.1-262.3,116.8-434.6l11.5-76.6l-149.3,145.5c-178.1,174.2-227.8,208.7-296.8,208.7c-124.4,0-225.9-113-199.1-222.1c9.6-36.4,151.3-193.4,428.9-472.9L6771-2148l388.7,386.7c214.4,214.4,402.1,411.6,417.4,440.4c42.1,82.3,32.5,157-28.7,224c-45.9,47.9-70.8,59.4-135.9,59.4c-78.5,0-91.9-9.6-268-181.9l-185.7-183.8l-11.5,124.5c-46,482.5-325.5,997.5-716.1,1313.4C5830.9,358.2,5270,522.9,4779.8,461.6z"></path><path d="M2811.6-1052.8c-365.7-367.6-415.5-425-415.5-478.6c0-88.1,36.4-151.3,105.3-185.7c34.5-15.3,72.8-28.7,86.2-28.7c53.6,0,155.1,72.8,298.7,214.4l155.1,153.2l11.5-227.8c17.2-323.6,90-570.5,250.8-853.9c275.7-482.5,752.4-830.9,1296.2-943.9c218.3-47.9,585.9-47.9,800.3-1.9c225.9,47.9,465.2,149.3,664.3,279.5c229.8,151.2,298.7,225.9,302.5,327.4c1.9,68.9-7.7,88.1-63.2,137.9c-91.9,82.3-174.2,68.9-342.7-61.3c-622.2-480.6-1510.6-425-2067.8,130.2c-281.4,279.6-461.4,708.4-463.3,1093.3v124.4l178.1-174.2c101.5-99.6,201-181.9,231.7-189.5c122.5-30.6,264.2,111,233.6,233.6c-9.6,36.4-153.2,195.3-419.3,463.3c-222.1,222.1-409.7,405.9-415.5,405.9C3232.8-635.4,3041.4-823.1,2811.6-1052.8z"></path>
                                            </g>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {Selected_multiple_serial.length > 0 && <button type="button" onClick={(e) => { Merge_multiple_scan_serial(); }} className="btn btn-primary" data-bs-dismiss="modal">Save</button>}
                    <button className="btn btn-danger rounded" onClick={() => { setScannerModalShow(false); }}>Close</button>
                </Modal.Footer>
            </Modal>

            <Modal show={BatchInModalShow} onHide={() => { }} dialogClassName="h-modal-75" centered>
                <Modal.Header>
                    <Modal.Title>Add Batch(s)</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setBatchInModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-body scroll-y mx-5  pt-0 ">
                        {(Tracking_inventory == "Track Batches" && Math.sign(Number(Quantity_adjust)) === 1) &&
                            <>
                                <div className="row gx-12 gy-8 mt-3">
                                    {
                                        stockData.length > 0 && stockData.map((obj, index) => {
                                            return (
                                                <>
                                                    <div key={index} className="d-flex flex-wrap gap-5">
                                                        <div className="fv-row w-100 flex-md-root">
                                                            <label className="required form-label">Batch Reference</label>
                                                            <input type="text" className="form-control mb-2" placeholder="Enter Batch Reference" disabled={obj.existing_flag} value={obj.Batch_Reference}
                                                                onBlur={(e) => {
                                                                    if (e.target.value != "") {
                                                                        let temp_arr = [...stockData];
                                                                        if (stockData.find((elem, indx) => elem.Batch_Reference == e.target.value && indx !== index) !== undefined) {
                                                                            swal("Warning!", "Same batch reference already selected.", "warning").then((value) => {
                                                                            });
                                                                            temp_arr[index].Batch_Reference = "";
                                                                        }
                                                                        else {
                                                                            SearchBatchSerialInformation(e.target.value, "Batch", index);
                                                                        }
                                                                        setStockData(temp_arr);
                                                                    }
                                                                }}
                                                                onChange={(e) => {
                                                                    let temp_arr = [...stockData];
                                                                    temp_arr[index].Batch_Reference = e.target.value;
                                                                    setStockData(temp_arr);
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="fv-row w-100 flex-md-root">
                                                            <label className="require form-label">Manufacturer Batch</label>
                                                            <input type="text" className="form-control mb-2" placeholder="Enter Manufacturer Batch" value={obj.Manufacture_Batch} onChange={(e) => {
                                                                const values1 = [...stockData];
                                                                values1[index].Manufacture_Batch = e.target.value;
                                                                setStockData(values1);
                                                            }} />
                                                        </div>
                                                        <div className="fv-row w-100 flex-md-root">
                                                            <label className="require form-label">Manufactured Date</label>
                                                            <input type="date" name="Stock_date" className="form-control" placeholder="Sales Start Date" value={obj.Manufacture_Date}
                                                                onChange={(e) => {
                                                                    const values1 = [...stockData];
                                                                    values1[index].Manufacture_Date = e.target.value;
                                                                    setStockData(values1);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-wrap gap-5">
                                                        <div className="fv-row w-100 flex-md-root">
                                                            <label className="require form-label">Expiry Date</label>
                                                            <input type="date" name="Stock_date" className="form-control" placeholder="Sales Start Date" value={obj.Expiry_Date}
                                                                onChange={(e) => {
                                                                    const values1 = [...stockData];
                                                                    values1[index].Expiry_Date = e.target.value;
                                                                    setStockData(values1);
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="fv-row w-100 flex-md-root">
                                                            <label className="required form-label">{obj.Available_Quantity != undefined ? <>New Quantity</> : <>Quantity In</>}</label>
                                                            <input type="number" min="0" className="form-control mb-2" placeholder="Enter Quantity" value={obj.Quantity_In.toString()} onChange={(e) => {
                                                                const values1 = [...stockData];
                                                                const amount = e.target.value == "" ? 0 : parseFloat(e.target.value);
                                                                let totalQuantity_In = stockData.reduce(function (sum, tax) {
                                                                    return Number(sum) + Number(tax.Quantity_In);
                                                                }, 0);
                                                                if (Number(amount) > Number(Quantity_adjust)) {
                                                                    swal("Oops!", "Quantity In value can't be greater than Adjust Quantity.", "warning")
                                                                    values1[index].Quantity_In = 0;
                                                                }
                                                                if (Number(totalQuantity_In) > Number(Quantity_adjust)) {
                                                                    swal("Oops!", "Total Quantity can't be greater than Adjust Quantity.", "warning")
                                                                    values1[index].Quantity_In = 0;
                                                                }
                                                                else {
                                                                    values1[index].Quantity_In = amount;
                                                                }
                                                                setStockData(values1);
                                                            }} />
                                                            {obj.Available_Quantity != undefined && <div className="text-muted fs-7">Qunatity Available in batch:{obj.Available_Quantity}</div>}
                                                        </div>
                                                        {stockData.length > 1 &&
                                                            <div className="fv-row w-100 flex-md-root">
                                                                <label className="require form-label"></label><br />
                                                                <a onClick={(event) => { Remove_serial_batch_section(index); }} data-repeater-delete="" className="btn btn-sm font-weight-bolder btn-light-danger cursor-pointer">
                                                                    <i className="la la-trash-o"></i>Delete</a>
                                                            </div>}
                                                    </div>

                                                </>
                                            )
                                        })
                                    }
                                </div>
                                {(stockData.reduce(function (sum, tax) { return Number(sum) + Number(tax.Quantity_In) }, 0) < Number(Quantity_adjust)) &&
                                    <button data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} onClick={(e) => {
                                        Add_serial_batch_section();
                                    }} className="btn btn-sm btn-primary me-3 rounded mt-3">
                                        <span className="svg-icon svg-icon-2">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor"></rect>
                                                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"></rect>
                                            </svg>
                                        </span>
                                        <span className="indicator-label">Add Batches</span>
                                        <span className="indicator-progress">Please wait...
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>}
                            </>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { reset_serial_batch_section(); }} className="btn btn-warning" data-bs-dismiss="modal">Reset</button>
                    <button type="button" onClick={(e) => { setBatchInModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" onClick={(e) => { stockValidationCheck(productId) && setBatchInModalShow(false) }} className="btn btn-success" data-bs-dismiss="modal">save</button>

                </Modal.Footer>
            </Modal>

            <Modal show={CustomerModalShow} onHide={() => { clearFormCustomer() }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Add Customer</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { clearFormCustomer() }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="row mb-5">
                            <div className='col-4 my-auto'>
                                <label className="fs-5 fw-bold mb-2">Customer Type</label>
                            </div>
                            <div className='col-4'>
                                <label className="fs-5 mb-2" onClick={() => { setCustomerType("business") }}> Business
                                    <input type="radio" className="form-check-input ms-5" checked={customerType === "business"} readOnly />
                                </label>
                            </div>
                            <div className='col-4'>
                                <label className="fs-5 mb-2" onClick={() => { setCustomerType("individual") }}>Individual
                                    <input type="radio" className="form-check-input ms-5" checked={customerType === "individual"} readOnly />
                                </label>
                            </div>
                        </div>

                        <div className="row mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 fw-bold mb-2">Primary Contact</label>
                            </div>
                            <div className='col-3 my-auto'>
                                <Select
                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                    options={["Mr.", "Mrs.", "Miss.", "Dr.", "M/s", "Prof."].map(x => { return { label: x, value: x } })}
                                    value={primaryContact.salutation}
                                    onChange={(val) => {
                                        setPrimaryContact({ ...primaryContact, salutation: val })
                                    }}
                                    isClearable
                                    placeholder="Salutation"
                                />
                            </div>
                            <div className='col-6 input-group-text p-0'>
                                <input type="text" className="form-control form-control-solid" value={primaryContact.firstName} onChange={(e) => { setPrimaryContact({ ...primaryContact, firstName: e.target.value }) }} placeholder='First Name' />
                                <input type="text" className="form-control form-control-solid" value={primaryContact.lastName} onChange={(e) => { setPrimaryContact({ ...primaryContact, lastName: e.target.value }) }} placeholder='Last Name' />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-md-6 my-auto">
                                <label className="required fs-5 fw-bold mb-2">Customer Display Name</label>
                                <Select
                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                    options={customerDisplayNameOptions.map(x => { return { label: x, value: x } })}
                                    value={selectedCustomerDisplayName}
                                    onChange={(val) => { setSelectedCustomerDisplayName(val) }}
                                />
                            </div>
                        </div>

                        <div className="row mb-5">
                            <div className="col-md-4">
                                <label className="required fs-5 fw-bold mb-2">Work Phone</label>
                                <input type="number" className="form-control form-control-solid" value={workPhone} onChange={(e) => { setWorkPhone(e.target.value) }} />
                            </div>
                            <div className="col-md-4">
                                <label className="fs-5 fw-bold mb-2">Mobile</label>
                                <input type="number" className="form-control form-control-solid" min={0} value={mobile} onChange={(e) => { setMobile(e.target.value) }} />
                            </div>
                            <div className="col-md-4">
                                <label className={"fs-5 fw-bold mb-2"}>Email</label>
                                <input type="email" className="form-control form-control-solid" value={email} onChange={(e) => { setEmail(e.target.value) }} />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className="required fs-5 fw-bold mb-2">Place Of Supply</label>
                                <Select
                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                    options={SupplyStateOptions}
                                    onChange={(val) => { setPlaceSupply(val) }}
                                    value={placeSupply}
                                    isClearable
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="required fs-5 fw-bold mb-2">GST Treatment</label>
                                <Select
                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                    options={gstTreatmentlist}
                                    value={gstTreatment}
                                    onChange={(val) => { setGstTreatment(val); setGstIN(""); setLegalName(""); setTradeName("") }}
                                    components={{
                                        Option: (props) => {
                                            //console.log(props);
                                            return (
                                                <components.Option  {...props}>
                                                    {props.children}
                                                    <span className="fw-semibold text-gray-400 d-block fs-8">{props.data.description}</span>
                                                </components.Option >
                                            )
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        {
                            (gstTreatment !== null && (gstTreatment.value !== "Consumer" && gstTreatment.value !== "Unregistered Business")) &&
                            <div className="row mb-5">
                                <label className="required fs-5 fw-bold mb-2">GSTIN</label>
                                {/* <div className="row">
                                    <input id="GSTIN" type="text" className="form-control col-md-10 mb-2" placeholder="" name="GSTIN" value={GstIN} onChange={(e) => { setGstIN(e.target.value) }} />
                                    {
                                        <button className="btn btn-sm btn-secondary col-md-2 gap-2" disabled={gstinSearchDetailsApiState}
                                            onClick={() => {
                                                if (!gstinRegex.test(GstIN)) {
                                                    swal("Warning!", "Invalid GSTIN format", "warning");
                                                    return
                                                }
                                                getGstinSearchDetails(GstIN)
                                            }}
                                        >
                                            {
                                                gstinSearchDetailsApiState === true ?
                                                    <span className="spinner-border spinner-border-sm align-middle"></span>
                                                    :
                                                    gstinSearchDetails === null ?
                                                        <span className="text-dark">Verify</span> :
                                                        <i className="bi bi-patch-check-fill text-success fs-2 p-0"></i>
                                            }
                                        </button>
                                    }
                                </div> */}
                                {/* <div className="row mb-2">
                                    <div className="col-md-10 mb-2">
                                        <input id="GSTIN" type="text" className="form-control" placeholder="" name="GSTIN" value={GstIN} onChange={(e) => { setGstIN(e.target.value) }} />
                                    </div>
                                    <div className="col-md-2">
                                        <button className="btn btn-sm btn-secondary gap-2" disabled={gstinSearchDetailsApiState}
                                            onClick={() => {
                                                if (!gstinRegex.test(GstIN)) {
                                                    swal("Warning!", "Invalid GSTIN format", "warning");
                                                    return;
                                                }
                                                getGstinSearchDetails(GstIN);
                                            }}
                                        >
                                            {
                                                gstinSearchDetailsApiState === true ?
                                                    <span className="spinner-border spinner-border-sm align-middle"></span>
                                                    :
                                                    gstinSearchDetails === null ?
                                                        <span className="text-dark">Verify</span> :
                                                        <i className="bi bi-patch-check-fill text-success fs-2 p-0"></i>
                                            }
                                        </button>
                                    </div>
                                </div> */}

                                <div className='row'>
                                    <div className="col-md-6 fv-row">
                                        <label className="required fs-5 fw-bold mb-2">Business Legal Name</label>
                                        <input id="Business_Legal_Name" type="text" className="form-control mb-2" placeholder="" name="Business_Legal_Name" value={LegalName} onChange={(e) => { setLegalName(e.target.value) }} />
                                    </div>
                                    <div className="col-md-6 fv-row">
                                        <label className="fs-5 fw-bold mb-2">Business Trade Name</label>
                                        <input id="Business_Trade_Name" type="text" className="form-control mb-2" placeholder="" name="Business_Trade_Name" value={TradeName} onChange={(e) => { setTradeName(e.target.value) }} />
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className={`${billingAddressFlag === true && "required "} required fs-5 fw-bold mb-2`}>Country</label>
                                <Select
                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                    options={billingCountryOptions}
                                    value={billingSelectedCountry}
                                    onChange={(val) => { setBillingSelectedCountry(val); setBillingSelectedState(null); loadBillingStateOptions(val); }}
                                />
                            </div>

                            <div className="col-md-6">
                                <label className={`${billingAddressFlag === true && "required "} required fs-5 fw-bold mb-2`}>State / Province / Region</label>
                                <Select
                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                    options={billingStateOptions}
                                    value={billingSelectedState}
                                    onChange={(val) => { setBillingSelectedState(val) }}
                                />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-md-12">
                                <label className="fs-5 fw-bold mb-2">Address Line 1</label>
                                <input type="text" className="form-control form-control-solid" value={billingAddress1} onChange={(e) => { setBillingAddress1(e.target.value) }} />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className={`${billingAddressFlag === true && "required "} required fs-5 fw-bold mb-2`}>Town/City</label>
                                <input type="text" className="form-control form-control-solid" value={billingCity} onChange={(e) => { setBillingCity(e.target.value) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${billingAddressFlag === true && "required "} required fs-5 fw-bold mb-2`}>Pin Code</label>
                                <input type="text" className="form-control form-control-solid" value={billingPincode} onChange={(e) => { setBillingPincode(e.target.value) }}
                                    onBlur={(e) => {
                                        const shiprocketRegex = /^(?=.*\b\d+\b).{11,}$/;
                                        if (!billingAddress1.match(shiprocketRegex)) {
                                            setBillingAddress1(`${billingAddress1} ${billingCity} ${billingPincode}`)
                                        }
                                    }} />
                            </div>
                        </div>
                        <label className="form-check form-check-custom form-check-solid align-items-start">
                            <input className="form-check-input me-3" type="checkbox" checked={Shipping_flag} onChange={(e) => { setShipping_flag(e.target.checked); }} />
                            <span className="form-check-label d-flex flex-column align-items-start">
                                <span className="fw-bolder fs-5 mb-0">Use the same address for shipping.</span>
                            </span>
                        </label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary rounded" onClick={() => { clearFormCustomer(); }}>Close</button>
                    {
                        write &&
                        <button className="btn btn-primary rounded" data-kt-indicator={customerSubmitButtonState ? "on" : "off"} disabled={customerSubmitButtonState} onClick={() => { submitCustomerDetails() }}>
                            <span className="indicator-label"><i className="bi bi-save2-fill"></i>Save and Continue</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>

            <Modal show={gstInListModalShow} onHide={() => { setGstInListModalShow(false) }} centered>
                <Modal.Header>
                    <Modal.Title>GstIn List</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setGstInListModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: "#f4f6f9" }}>
                    <div className='container'>
                        {
                            customerGstinList.length === 0 ?
                                <div className="overflow-auto pb-5">
                                    <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed min-w-lg-600px flex-shrink-0 p-6">
                                        <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.3" d="M19.0687 17.9688H11.0687C10.4687 17.9688 10.0687 18.3687 10.0687 18.9688V19.9688C10.0687 20.5687 10.4687 20.9688 11.0687 20.9688H19.0687C19.6687 20.9688 20.0687 20.5687 20.0687 19.9688V18.9688C20.0687 18.3687 19.6687 17.9688 19.0687 17.9688Z" fill="currentColor"></path>
                                                <path d="M4.06875 17.9688C3.86875 17.9688 3.66874 17.8688 3.46874 17.7688C2.96874 17.4688 2.86875 16.8688 3.16875 16.3688L6.76874 10.9688L3.16875 5.56876C2.86875 5.06876 2.96874 4.46873 3.46874 4.16873C3.96874 3.86873 4.56875 3.96878 4.86875 4.46878L8.86875 10.4688C9.06875 10.7688 9.06875 11.2688 8.86875 11.5688L4.86875 17.5688C4.66875 17.7688 4.36875 17.9688 4.06875 17.9688Z" fill="currentColor"></path>
                                            </svg>
                                        </span>
                                        <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                                            <div className="mb-3 mb-md-0 fw-semibold">
                                                <h4 className="text-gray-900 fw-bold">No Data Available.</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <>
                                    <div className="d-flex flex-column gap-5">

                                        {
                                            customerGstinList.sort((a, b) => a.add_date_time - b.add_date_time).map((obj, index) => {
                                                return (
                                                    <div key={index} className="position-relative fv-row w-100 flex-md-root" style={{ cursor: "pointer" }} onClick={() => { setSelectedGstin(obj); setSelectedPlaceOfSupply({ label: obj.place_of_supply, value: obj.place_of_supply }); setGstInListModalShow(false); }}>
                                                        <div className="card card-flush h-lg-100">
                                                            <div className="card-header mt-6">
                                                                <div className="card-title flex-column"><h3 className="fw-bolder mb-1">{obj.GstIn}</h3></div>
                                                            </div>
                                                            <div className="d-flex flex-wrap">
                                                                <div className="card-body p-9">
                                                                    <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                        <div className="fs-6 fw-bold text-gray-700">{obj.legal_name}</div>
                                                                        <div className="fw-semibold text-gray-400">Business Legal Name</div>
                                                                    </div>
                                                                    <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                        <div className="fs-6 fw-bold text-gray-700">{obj.gst_treatment}</div>
                                                                        <div className="fw-semibold text-gray-400">GST Treatment</div>
                                                                    </div>
                                                                    <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                        <div className="fs-6 fw-bold text-gray-700">{obj.place_of_supply}</div>
                                                                        <div className="fw-semibold text-gray-400">Place of Supply</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {
                                                            selectedGstin != null && selectedGstin.unique_id === obj.unique_id &&
                                                            <div className='position-absolute' style={{ top: "3rem", right: "7rem" }} >
                                                                <svg width="30" height="30" viewBox="0 0 64 64">
                                                                    <path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50  l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047" />
                                                                </svg>
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className='btn btn-success'
                        onClick={() => {
                            setModalData({
                                apiCallback: () => { getCustomerGstinDetails(selectedCustomer.value) },
                                entityType: "CUSTOMER",
                                entityId: selectedCustomer.value,
                                page_name,
                            })
                            setModalView("GSTIN_MODAL")
                            openModal()
                        }}
                    >
                        <i className="las la-plus"></i>
                        Add New
                    </button>
                    <button className="btn btn-danger rounded" onClick={() => { setGstInListModalShow(false) }}>Close</button>
                </Modal.Footer>
            </Modal>

            <Modal show={ItemModalShow} onHide={() => { setItemModalShow(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Add Item</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setItemModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="fv-row mb-10">
                            <label className="fs-6 fw-semibold mb-2">Type</label>
                            <div className="row">
                                <div className="col">
                                    <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 ${Product_type === "Goods" && "active"}`} data-kt-button="true">
                                        <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                            <input className="form-check-input" type="radio" name="discount_option" value="2" onChange={(e) => { setProduct_type("Goods") }} checked={Product_type === "Goods"} />
                                        </span>
                                        <span className="ms-5"><span className="fs-4 fw-bold text-gray-800 d-block">Goods</span></span>
                                    </label>
                                </div>
                                <div className="col">
                                    <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 ${Product_type === "Service" && "active"}`} data-kt-button="true">
                                        <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                            <input className="form-check-input" type="radio" name="discount_option" value="3" onChange={(e) => { setProduct_type("Service") }} checked={Product_type === "Service"} />
                                        </span>
                                        <span className="ms-5"><span className="fs-4 fw-bold text-gray-800 d-block">Service</span></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="mb-5">
                            <label className="required form-label">Item Name</label>
                            <input type="text" name="product_name" className="form-control mb-2" placeholder="Item name" value={ItemName} onChange={(e) => { setItemName(e.target.value) }} />
                            <div className="text-muted fs-7">A Item name is required and recommended to be unique.</div>
                        </div>
                        <div className="mb-5">
                            <label className="required form-label">Unit</label>
                            <Select
                                styles={theme == 'dark' ? dropdownStyleDark : {}}
                                options={UnitSelectionList}
                                onChange={(event) => { setUnit(event.value); }}
                                value={UnitSelectionList.filter(option => option.value == Unit).length != 0 && UnitSelectionList.filter(option => option.value == Unit)[0]}
                                placeholder="--Select product Unit--"
                            />
                            <div className="text-muted fs-7">Enter the product Unit.</div>
                        </div>
                        <div className="mb-5">
                            <label className="required form-label">Tax Preference</label>
                            <Select
                                styles={theme == 'dark' ? dropdownStyleDark : {}}
                                options={TaxSelectionList}
                                onChange={(event) => { setTaxPreference(event.value); }}
                                value={TaxSelectionList.filter(option => option.value == TaxPreference).length != 0 && TaxSelectionList.filter(option => option.value == TaxPreference)[0]}
                                placeholder="--Select Tax Preference--"
                            />
                            <div className="text-muted fs-7">Enter the Tax Preference.</div>
                        </div>
                        {
                            TaxPreference == "Taxable" &&
                            <>
                                <div className="mb-5">
                                    <label className="fs-6 fw-semibold mb-2">Tax Calculation Method</label>
                                    <div className="d-flex align-items-center">
                                        <div className={`rounded mx-2 px-6 py-2 ${TaxCalculationMethod == "TAX_Inclusive" && "bg-primary"}`} onClick={() => { setTaxCalculationMethod("TAX_Inclusive"); }}>TAX Inclusive</div>
                                        <div className={`rounded mx-2 px-6 py-2 ${TaxCalculationMethod == "TAX_Exclusive" && "bg-primary"}`} onClick={() => { setTaxCalculationMethod("TAX_Exclusive"); }}>TAX Exclusive</div>
                                    </div>
                                </div>
                                <div className="mb-5">
                                    <label className="form-label">Intra State Tax Rate</label>
                                    <Select
                                        styles={theme == 'dark' ? dropdownStyleDark : {}}
                                        options={taxGroupList.filter(x => x.tax_group_type != "INTERSTATE").map(x => { return { label: x.tax_group_name, value: x.tax_group_id } })}
                                        onChange={(event) => { Default_tax_preference.Intra_State_Tax = event.value; }}
                                        value={Default_tax_preference.Intra_State_Tax != "" && { label: taxGroupList.find(x => x.tax_group_id == Default_tax_preference.Intra_State_Tax).tax_group_name, value: Default_tax_preference.Intra_State_Tax }}
                                        placeholder="--Select Intra state tax group--"
                                    />
                                    <div className="text-muted fs-7">Set the Intra State Tax Rate.</div>
                                </div>
                                <div className="mb-5">
                                    <label className="form-label">Inter State Tax Rate</label>
                                    <Select
                                        styles={theme == 'dark' ? dropdownStyleDark : {}}
                                        options={taxGroupList.filter(x => x.tax_group_type == "INTERSTATE").map(x => { return { label: x.tax_group_name, value: x.tax_group_id } })}
                                        onChange={(event) => { Default_tax_preference.Inter_State_Tax = event.value; }}
                                        value={Default_tax_preference.Inter_State_Tax != "" && { label: taxGroupList.find(x => x.tax_group_id == Default_tax_preference.Inter_State_Tax).tax_group_name, value: Default_tax_preference.Inter_State_Tax }}
                                        placeholder="--Select Inter state tax group--"
                                    />
                                    <div className="text-muted fs-7">Set the Inter State Tax Rate.</div>
                                </div>
                            </>
                        }

                        <label className="form-check form-check-custom form-check-solid align-items-start">
                            <input className="form-check-input me-3" type="checkbox" name="email-preferences[]" checked={Tracking_inventory === true} value={Tracking_inventory} onChange={(e) => { setTracking_inventory(e.target.checked) }} />
                            <span className="form-check-label d-flex flex-column align-items-start">
                                <span className="fw-bolder fs-5 mb-0">Track Inventory for this item</span>
                                {Tracking_inventory && <span className="text-muted fs-6">You cannot enable/disable inventory tracking once you've created transactions for this item</span>}
                            </span>
                        </label>

                        {
                            Tracking_inventory === true &&
                            <div className="mb-5">
                                <label className="required fw-semibold fs-6 mb-5">Advanced Inventory Tracking</label>
                                <div className="d-flex fv-row">
                                    <div className="form-check form-check-custom form-check-solid">
                                        <input className="form-check-input me-3" name="user_role" type="radio" onChange={(e) => { setTracking_inventory_type("None") }} checked={Tracking_inventory_type === "None"} />
                                        <label className="form-check-label" for="kt_modal_update_role_option_0">
                                            <div className="fw-bold text-gray-800">None</div>
                                            <div className="text-gray-600"></div>
                                        </label>
                                    </div>
                                </div>
                                <div className="separator separator-dashed my-5"></div>
                                <div className="d-flex fv-row">
                                    <div className="form-check form-check-custom form-check-solid">
                                        <input className="form-check-input me-3" name="user_role" type="radio" onChange={(e) => { setTracking_inventory_type("Track Serial Number") }} checked={Tracking_inventory_type === "Track Serial Number"} />
                                        <label className="form-check-label" for="kt_modal_update_role_option_1">
                                            <div className="fw-bold text-gray-800">Track Serial Number</div>
                                            <div className="text-gray-600"></div>
                                        </label>
                                    </div>
                                </div>
                                <div className="separator separator-dashed my-5"></div>
                                <div className="d-flex fv-row">
                                    <div className="form-check form-check-custom form-check-solid">
                                        <input className="form-check-input me-3" name="user_role" type="radio" onChange={(e) => { setTracking_inventory_type("Track Batches") }} checked={Tracking_inventory_type === "Track Batches"} />
                                        <label className="form-check-label" for="kt_modal_update_role_option_2">
                                            <div className="fw-bold text-gray-800">Track Batches</div>
                                            <div className="text-gray-600"></div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setItemModalShow(false) }}>Close</button>
                    {
                        write &&
                        <button className="btn btn-success rounded" data-kt-indicator={itemSubmitButtonState ? "on" : "off"} disabled={itemSubmitButtonState} onClick={() => { submitItemDetails() }}>
                            <span className="indicator-label">Save and Continue</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>

            <Modal show={termsModalShow} onHide={() => { handleNewTermsModalClose() }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Configure Payment Terms</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleNewTermsModalClose() }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="row">
                            <div className='col-5 text-center'>
                                <label className="fs-5 fw-bold my-2 required">Term Name</label>
                            </div>
                            <div className='col-5 text-center'>
                                <label className="fs-5 fw-bold my-2 required">Number of Days</label>
                            </div>
                        </div>
                        {
                            termsPanelList.length > 0 ?
                                termsPanelList.map((x, indx) => {
                                    return (
                                        <div key={indx} className="row mb-2">
                                            <div className='col-5'>
                                                <input type="text" className="form-control form-control-solid" value={x.term_name}
                                                    onChange={(e) => {
                                                        let temp = termsPanelList.map(x => { return { ...x } })
                                                        temp[indx].term_name = e.target.value
                                                        setTermsPanelList(temp)
                                                    }}
                                                />
                                            </div>
                                            <div className='col-5'>
                                                <input type="number" min="0" className="form-control form-control-solid" value={x.no_of_days}
                                                    onChange={(e) => {
                                                        if (e.target.value >= 0) {
                                                            let temp = termsPanelList.map(x => { return { ...x } })
                                                            temp[indx].no_of_days = e.target.value
                                                            setTermsPanelList(temp)
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className='col-2 my-auto'>
                                                <button className='btn btn-sm btn-outline-danger rounded-pill border border-danger'
                                                    onClick={() => {
                                                        let temp = termsPanelList.map(a => { return { ...a } })
                                                        temp.splice(indx, 1)
                                                        setTermsPanelList(temp)
                                                    }}
                                                >&#10006;</button>
                                            </div>
                                        </div>
                                    )
                                })
                                :
                                <p className='text-center'>No terms available. Create a new term</p>
                        }
                        <div className="row">
                            <div className='col-6'>
                                <button className='btn btn-link' onClick={() => { setTermsPanelList([...termsPanelList, { term_name: "", no_of_days: "" }]) }} >Add a term</button>
                            </div>
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {
                        write &&
                        <button className="btn btn-success rounded me-auto" data-kt-indicator={termsSubmitButtonState ? "on" : "off"} disabled={termsSubmitButtonState} onClick={() => { newTermsSubmit() }}>
                            <span className="indicator-label">Save and Continue</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                    <button className="btn btn-danger rounded" onClick={() => { handleNewTermsModalClose() }}>Close</button>
                </Modal.Footer>
            </Modal>

            <Modal show={AddressModalShow} onHide={() => { setAddressModalShow(false); }} centered>
                <Modal.Header>
                    <Modal.Title>Select {AddressType === "billing" ? "Billing" : "Shipping"} Address</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setAddressModalShow(false); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="row gx-9 gy-6">
                            {
                                addressList.map((obj, indx) => {
                                    return (
                                        <div key={indx} className="card card-dashed flex-wrap p-6" style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                if (AddressType == "billing") {
                                                    setSelectedBillingAddress(obj)
                                                }
                                                else {
                                                    setSelectedShippingAddress(obj)
                                                }
                                                setAddressModalShow(false)
                                            }}
                                        >
                                            <div className="d-flex flex-column py-2">
                                                <div className="d-flex align-items-center fs-5 fw-bold mb-5">Address {indx + 1} {selectedBillingAddress != null && selectedBillingAddress.id === obj.id && "(Billing)"} {selectedShippingAddress != null && selectedShippingAddress.id === obj.id && "(Shipping)"} </div>
                                                <div className="fs-6 fw-semibold text-gray-600">
                                                    {obj.state}
                                                    <br />{obj.city},{obj.pincode}
                                                    <br />{obj.country}
                                                </div>
                                            </div>
                                            {
                                                (selectedBillingAddress != null && selectedShippingAddress != null) && (selectedBillingAddress.id === obj.id || selectedShippingAddress.id === obj.id) &&
                                                <div className='position-absolute' style={{ top: "1rem", right: "1rem" }} >
                                                    <svg width="30" height="30" viewBox="0 0 64 64">
                                                        <path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50  l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047" />
                                                    </svg>
                                                </div>
                                            }
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setAddressModalShow(false) }}>Close</button>
                </Modal.Footer>
            </Modal>

            <Modal show={productCodeModalShow} onHide={() => { setProductCodeModalShow(false); setProductCodeItemId(null); setProductCodeItemType(null); setProductCodeSearch(""); setProductCodeList([]); setProductCodeListApiState(false); }} centered>
                <Modal.Header>
                    <Modal.Title>Find {productCodeItemType == "Goods" ? "HSN" : "SAC"} Code</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setProductCodeModalShow(false); setProductCodeItemId(null); setProductCodeItemType(null); setProductCodeSearch(""); setProductCodeList([]); setProductCodeListApiState(false); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="scroll-y me-n7 pe-7" id="kt_modal_new_address_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_new_address_header" data-kt-scroll-wrappers="#kt_modal_new_address_scroll" data-kt-scroll-offset="300px">
                        <div className="container">

                            <label className="form-label">Search {productCodeItemType == "Goods" ? "HSN" : "SAC"} code for your item</label>
                            <div className="d-flex gap-1">
                                <input type="text" className="form-control" value={productCodeSearch} onChange={(e) => { setProductCodeSearch(e.target.value) }} />
                                <button className="btn btn-primary btn-sm rounded" onClick={(e) => { getProductCodeList(productCodeItemType, productCodeSearch) }} disabled={productCodeListApiState}>Search</button>
                            </div>

                            {
                                productCodeList.length > 0 && productCodeList.map((obj, index) => {
                                    return (
                                        <div key={index} className="d-flex align-items-center my-2"
                                            onClick={() => {
                                                setProductCodeModalShow(false);
                                                let temp = itemArray.map(a => { return { ...a } })
                                                let ti = itemArray.findIndex(x => x.item.value == productCodeItemId)
                                                temp[ti].item_popover_input = obj.codes
                                                setItemArray(temp)

                                                setProductCodeItemId(null);
                                                setProductCodeItemType(null);
                                                setProductCodeSearch("");
                                                setProductCodeList([]);
                                                setProductCodeListApiState(false);
                                            }}
                                        >
                                            <div className="symbol symbol-40px">
                                                <span className="symbol-label bg-light">
                                                    <span className="svg-icon svg-icon-2 svg-icon-primary">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M2 16C2 16.6 2.4 17 3 17H21C21.6 17 22 16.6 22 16V15H2V16Z" fill="currentColor"></path>
                                                            <path opacity="0.3" d="M21 3H3C2.4 3 2 3.4 2 4V15H22V4C22 3.4 21.6 3 21 3Z" fill="currentColor"></path>
                                                            <path opacity="0.3" d="M15 17H9V20H15V17Z" fill="currentColor"></path>
                                                        </svg>
                                                    </span>
                                                </span>
                                            </div>
                                            <div className="d-flex flex-column">
                                                <p className="fs-6 text-gray-800 text-hover-primary fw-semibold">{obj.code_description}</p>
                                                <span className="fs-7 text-muted fw-semibold">#{obj.codes}</span>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default EditCreditNote;